import type { Locale } from '../i18n/messages';
import legacyPostRouteAliases from './legacyPostRouteAliases.json';

export interface PostRouteEntry {
  slug: string;
  updatedAt: string;
  indexable: boolean;
  localizedSlugs: Record<Locale, string>;
}

interface LegacyPostRouteAlias {
  locale: Locale;
  legacySlug: string;
  baseSlug: string;
}

export const POST_ROUTE_INDEX: readonly PostRouteEntry[] = [
  {
    "slug": "best-free-passport-photo-makers-compared",
    "updatedAt": "2026-06-01",
    "indexable": true,
    "localizedSlugs": {
      "en": "best-free-passport-photo-makers-compared",
      "es": "best-free-passport-photo-makers-compared-no-signup-no-watermark-and-print-ready",
      "fr": "best-free-passport-photo-makers-compared-no-signup-no-watermark-and-print-ready",
      "ar": "best-free-passport-photo-makers-compared-no-signup-no-watermark-and-print-ready",
      "zh-Hans": "best-free-passport-photo-makers-compared-no-signup-no-watermark-and-print-ready",
      "de": "best-free-passport-photo-makers-compared-no-signup-no-watermark-and-print-ready",
      "pt": "best-free-passport-photo-makers-compared-no-signup-no-watermark-and-print-ready"
    }
  },
  {
    "slug": "passlens-vs-photoaid",
    "updatedAt": "2026-06-01",
    "indexable": true,
    "localizedSlugs": {
      "en": "passlens-vs-photoaid",
      "es": "passlens-vs-photoaid-free-vs-paid-passport-photo-maker-watermarks-and-privacy",
      "fr": "passlens-vs-photoaid-free-vs-paid-passport-photo-maker-watermarks-and-privacy",
      "ar": "passlens-vs-photoaid-free-vs-paid-passport-photo-maker-watermarks-and-privacy",
      "zh-Hans": "passlens-vs-photoaid-free-vs-paid-passport-photo-maker-watermarks-and-privacy",
      "de": "passlens-vs-photoaid-free-vs-paid-passport-photo-maker-watermarks-and-privacy",
      "pt": "passlens-vs-photoaid-free-vs-paid-passport-photo-maker-watermarks-and-privacy"
    }
  },
  {
    "slug": "free-alternative-to-paid-passport-photo-apps",
    "updatedAt": "2026-05-29",
    "indexable": true,
    "localizedSlugs": {
      "en": "free-alternative-to-paid-passport-photo-apps",
      "es": "free-alternative-to-paid-passport-photo-apps-no-subscription-no-watermark",
      "fr": "free-alternative-to-paid-passport-photo-apps-no-subscription-no-watermark",
      "ar": "free-alternative-to-paid-passport-photo-apps-no-subscription-no-watermark",
      "zh-Hans": "free-alternative-to-paid-passport-photo-apps-no-subscription-no-watermark",
      "de": "free-alternative-to-paid-passport-photo-apps-no-subscription-no-watermark",
      "pt": "free-alternative-to-paid-passport-photo-apps-no-subscription-no-watermark"
    }
  },
  {
    "slug": "passport-photo-wont-get-rejected-2026",
    "updatedAt": "2026-05-29",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-wont-get-rejected-2026",
      "es": "passport-photo-that-wont-get-rejected-in-the-new-ai-rule-size-and-passport-photo",
      "fr": "passport-photo-that-wont-get-rejected-in-the-new-ai-rule-size-and-passport-photo",
      "ar": "passport-photo-that-wont-get-rejected-in-the-new-ai-rule-size-and-passport-photo",
      "zh-Hans": "passport-photo-that-wont-get-rejected-in-the-new-ai-rule-size-and-passport-photo",
      "de": "passport-photo-that-wont-get-rejected-in-the-new-ai-rule-size-and-passport-photo",
      "pt": "passport-photo-that-wont-get-rejected-in-the-new-ai-rule-size-and-passport-photo"
    }
  },
  {
    "slug": "change-passport-photo-guide",
    "updatedAt": "2026-05-26",
    "indexable": true,
    "localizedSlugs": {
      "en": "change-passport-photo-guide",
      "es": "puedes-cambiar-la-foto-del-pasaporte-correccion-reemplazo-y-camb-change-passport",
      "fr": "peut-on-changer-la-photo-de-son-passeport-correction-remplacemen-change-passport",
      "ar": "هل-يمكنك-تغيير-صورة-جواز-السفر-تصحيح-الصورة-والاستبدال-وتغي-ر-ال-change-passport",
      "zh-Hans": "可以更换护照照片吗-美国护照照片更正-补办与外貌变化规则",
      "de": "kann-man-sein-passfoto-andern-korrektur-ersatz-und-aussehensande-change-passport",
      "pt": "e-possivel-mudar-a-foto-do-passaporte-correcao-substituicao-e-mu-change-passport"
    }
  },
  {
    "slug": "passport-photo-after-name-change-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-after-name-change-guide",
      "es": "foto-de-pasaporte-despues-de-un-cambio-de-nombre-matrimonio-divor-passport-photo",
      "fr": "photo-de-passeport-apres-un-changement-de-nom-mariage-divorce-ren-passport-photo",
      "ar": "صورة-جواز-السفر-بعد-تغيير-الاسم-الزواج-والطلاق-والتجديد-وقواعد-ال-passport-photo",
      "zh-Hans": "改名后的护照照片-结婚-离婚-续办与美国照片规则",
      "de": "passfoto-nach-namensanderung-ehe-scheidung-verlangerung-und-us-fotoregeln",
      "pt": "foto-de-passaporte-apos-mudanca-de-nome-casamento-divorcio-renova-passport-photo"
    }
  },
  {
    "slug": "indian-passport-renewal-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "indian-passport-renewal-guide",
      "es": "cuando-se-puede-renovar-un-pasaporte-indio-plazos-de-reemision-e-indian-passport",
      "fr": "quand-peut-on-renouveler-un-passeport-indien-delais-de-reemissio-indian-passport",
      "ar": "متى-يمكن-تجديد-جواز-السفر-الهندي-توقيت-ا-عادة-الا-صدار-في-passpo-indian-passport",
      "zh-Hans": "印度护照何时可以续办-passport-seva-补发时机-费用与-tatkaal-规则",
      "de": "wann-kann-ein-indischer-reisepass-erneuert-werden-passport-seva-indian-passport",
      "pt": "quando-um-passaporte-indiano-pode-ser-renovado-prazos-de-reemiss-indian-passport"
    }
  },
  {
    "slug": "mexican-passport-renewal-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "mexican-passport-renewal-guide",
      "es": "como-obtener-o-renovar-un-pasaporte-mexicano-mi-consulado-prime-mexican-passport",
      "fr": "comment-obtenir-ou-renouveler-un-passeport-mexicain-mi-consulad-mexican-passport",
      "ar": "كيف-تحصل-على-جواز-سفر-مكسيكي-ا-و-تجدده-mi-consulado-الا-صدار-ال-mexican-passport",
      "zh-Hans": "如何申请或续办墨西哥护照-mi-consulado-首次申请-续办与遗失情况",
      "de": "wie-man-einen-mexikanischen-reisepass-bekommt-oder-erneuert-mi-mexican-passport",
      "pt": "como-obter-ou-renovar-um-passaporte-mexicano-mi-consulado-prime-mexican-passport"
    }
  },
  {
    "slug": "certified-copy-of-passport-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "certified-copy-of-passport-guide",
      "es": "como-obtener-una-copia-certificada-de-registros-de-pasaporte-que-certified-copy",
      "fr": "comment-obtenir-une-copie-certifiee-des-dossiers-de-passeport-ce-certified-copy",
      "ar": "كيف-تحصل-على-نسخة-مصدقة-من-سجلات-جواز-السفر-ما-الذي-توفره-وزارة-ا-certified-copy",
      "zh-Hans": "如何获得护照记录的认证副本-美国国务院到底提供什么",
      "de": "wie-man-eine-beglaubigte-kopie-von-passunterlagen-bekommt-was-das-certified-copy",
      "pt": "como-obter-uma-copia-certificada-de-registros-de-passaporte-o-que-certified-copy"
    }
  },
  {
    "slug": "dv-lottery-photo-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "dv-lottery-photo-guide",
      "es": "requisitos-de-foto-para-la-loteria-dv-reglas-de-imagen-para-la-divers-dv-lottery",
      "fr": "exigences-photo-pour-la-loterie-dv-regles-dimage-pour-lentree-diversi-dv-lottery",
      "ar": "متطلبات-صورة-قرعة-dv-قواعد-صورة-برنامج-الهجرة-العشواي-ية-قص-600x600-و-dv-lottery",
      "zh-Hans": "dv-抽签-照片要求-多元化签证报名照片规则-600x600-裁切与常见拒绝原因",
      "de": "dv-lotterie-fotoanforderungen-bildregeln-fur-die-diversity-visa-einre-dv-lottery",
      "pt": "requisitos-de-foto-para-a-loteria-dv-regras-da-imagem-para-a-diversit-dv-lottery"
    }
  },
  {
    "slug": "costco-passport-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "costco-passport-photo-guide",
      "es": "costco-y-la-foto-de-pasaporte-si-costco-aun-imprime-fotos-de-pas-costco-passport",
      "fr": "photo-de-passeport-chez-costco-costco-imprime-t-il-encore-des-ph-costco-passport",
      "ar": "كوستكو-وصور-جواز-السفر-هل-لا-تزال-costco-تطبع-صور-الجواز-وما-البديل-الا-فضل",
      "zh-Hans": "costco-护照照片-costco-现在还提供护照照片吗-以及该用什么替代",
      "de": "costco-und-passfotos-druckt-costco-noch-passfotos-und-was-sollte-costco-passport",
      "pt": "costco-e-foto-para-passaporte-a-costco-ainda-imprime-fotos-para-costco-passport"
    }
  },
  {
    "slug": "passport-eligibility-and-travel-exceptions-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-eligibility-and-travel-exceptions-guide",
      "es": "puedes-obtener-un-pasaporte-con-una-orden-pendiente-delitos-passport-eligibility",
      "fr": "peut-on-obtenir-un-passeport-avec-un-mandat-delits-carte-ve-passport-eligibility",
      "ar": "هل-يمكنك-الحصول-على-جواز-سفر-مع-مذكرة-توقيف-القضايا-الجناي-passport-eligibility",
      "zh-Hans": "有逮捕令还能办护照吗-重罪-绿卡出行-免签概念与美国岛屿路线",
      "de": "kann-man-mit-haftbefehl-einen-reisepass-bekommen-straftaten-passport-eligibility",
      "pt": "e-possivel-obter-passaporte-com-mandado-crimes-green-card-i-passport-eligibility"
    }
  },
  {
    "slug": "what-to-do-with-old-passport",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "what-to-do-with-old-passport",
      "es": "que-hacer-con-un-pasaporte-viejo-conservarlo-reemplazarlo-o-reportarlo-c-what-to",
      "fr": "que-faire-dun-ancien-passeport-le-conserver-le-remplacer-ou-le-declarer-what-to",
      "ar": "ماذا-تفعل-بجواز-السفر-القديم-الاحتفاظ-به-ا-و-استبداله-ا-و-الا-بلاغ-عنه-ب-what-to",
      "zh-Hans": "旧护照怎么处理-保留-补办-还是正确申报",
      "de": "was-tun-mit-einem-alten-reisepass-aufbewahren-ersetzen-oder-richtig-melden",
      "pt": "o-que-fazer-com-um-passaporte-antigo-guardar-substituir-ou-reportar-do-j-what-to"
    }
  },
  {
    "slug": "how-long-are-passports-good-for",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "how-long-are-passports-good-for",
      "es": "cuanto-duran-los-pasaportes-vigencia-del-pasaporte-y-de-la-tarjeta-pasa-how-long",
      "fr": "combien-de-temps-un-passeport-est-il-valable-validite-du-passeport-et-d-how-long",
      "ar": "كم-تبلغ-مدة-صلاحية-جوازات-السفر-مدة-صلاحية-جواز-السفر-الا-مريكي-وبطاقة-how-long",
      "zh-Hans": "护照有效期有多久-美国护照本和护照卡对成人与儿童的有效期",
      "de": "wie-lange-sind-reisepasse-gultig-gultigkeit-von-us-reisepass-und-passka-how-long",
      "pt": "por-quanto-tempo-os-passaportes-valem-validade-do-passaporte-e-do-passp-how-long"
    }
  },
  {
    "slug": "quickest-way-to-get-a-passport",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "quickest-way-to-get-a-passport",
      "es": "la-forma-mas-rapida-de-obtener-un-pasaporte-urgencias-en-ee-uu-serv-quickest-way",
      "fr": "le-moyen-le-plus-rapide-dobtenir-un-passeport-urgence-aux-etats-uni-quickest-way",
      "ar": "ا-سرع-طريقة-للحصول-على-جواز-سفر-الحالات-العاجلة-في-الولايات-المتحدة-quickest-way",
      "zh-Hans": "最快拿到护照的方法-美国加急-紧急出行与续签时间",
      "de": "der-schnellste-weg-zum-reisepass-us-eilservice-notfalltermine-und-e-quickest-way",
      "pt": "a-forma-mais-rapida-de-obter-um-passaporte-urgencia-nos-eua-servico-quickest-way"
    }
  },
  {
    "slug": "35x40-photo-size-guide",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "35x40-photo-size-guide",
      "es": "foto-35x40-mm-cuando-se-confunde-con-35x45-y-como-evitar-errores-en-la-medida",
      "fr": "format-photo-35x40-mm-quand-on-le-confond-avec-le-35x45-et-comment-c-35x40-photo",
      "ar": "مقاس-الصورة-35x40-مم-متى-يختلط-مع-35x45-وكيف-تضبط-المقاس-الصحيح",
      "zh-Hans": "35x40-毫米照片尺寸-它何时会与-35x45-混淆-以及如何改对尺寸",
      "de": "35x40-mm-fotogroße-wann-sie-mit-35x45-verwechselt-wird-und-wie-du-di-35x40-photo",
      "pt": "foto-35x40-mm-quando-ela-e-confundida-com-35x45-e-como-acertar-o-tamanho"
    }
  },
  {
    "slug": "passport-photo-dress-code-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-dress-code-guide",
      "es": "que-ponerse-para-una-foto-de-pasaporte-sonrisa-joyas-gafas-y-lo-q-passport-photo",
      "fr": "que-porter-pour-une-photo-de-passeport-sourire-bijoux-lunettes-et-passport-photo",
      "ar": "ماذا-ترتدي-في-صورة-جواز-السفر-الابتسامة-والمجوهرات-والنظارات-وما-passport-photo",
      "zh-Hans": "护照照片穿什么-笑容-首饰-眼镜以及真正会导致被拒的细节",
      "de": "was-man-auf-einem-passfoto-tragen-sollte-lacheln-schmuck-brille-u-passport-photo",
      "pt": "o-que-vestir-para-a-foto-do-passaporte-sorriso-joias-oculos-e-o-q-passport-photo"
    }
  },
  {
    "slug": "passport-photo-jewelry-glasses-accessories-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-jewelry-glasses-accessories-guide",
      "es": "puedes-llevar-joyas-en-una-foto-de-pasaporte-pendientes-piercings-passport-photo",
      "fr": "peut-on-porter-des-bijoux-sur-une-photo-de-passeport-boucles-dore-passport-photo",
      "ar": "هل-يمكن-ارتداء-المجوهرات-في-صورة-جواز-السفر-الا-قراط-والثقوب-والن-passport-photo",
      "zh-Hans": "护照照片可以戴首饰吗-耳环-穿孔-眼镜和头巾规则",
      "de": "darf-man-schmuck-auf-dem-passfoto-tragen-ohrringe-piercings-brill-passport-photo",
      "pt": "pode-usar-joias-na-foto-do-passaporte-brincos-piercings-oculos-e-passport-photo"
    }
  },
  {
    "slug": "what-color-to-wear-for-passport-photo-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "what-color-to-wear-for-passport-photo-guide",
      "es": "que-color-llevar-para-una-foto-de-pasaporte-ropa-blanca-camisas-y-con-what-color",
      "fr": "quelle-couleur-porter-pour-une-photo-de-passeport-vetements-blancs-ch-what-color",
      "ar": "ما-اللون-المناسب-لملابس-صورة-جواز-السفر-الملابس-البيضاء-والتباين-مع-الخلفية",
      "zh-Hans": "护照照片穿什么颜色-衬衫-白色衣服与背景对比",
      "de": "welche-farbe-furs-passfoto-hemden-weiße-kleidung-und-hintergrundkontrast",
      "pt": "que-cor-usar-na-foto-do-passaporte-camisa-roupa-branca-e-contraste-com-o-fundo"
    }
  },
  {
    "slug": "passport-photo-size-guide",
    "updatedAt": "2026-07-03",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-size-guide",
      "es": "guia-de-tamanos-de-foto-de-pasaporte-requisitos-por-pais",
      "fr": "guide-des-tailles-de-photo-de-passeport-exigences-par-pays",
      "ar": "دليل-مقاسات-صور-جواز-السفر-متطلبات-كل-دولة",
      "zh-Hans": "护照照片尺寸指南-各国要求",
      "de": "passfoto-großenleitfaden-anforderungen-nach-land",
      "pt": "guia-de-tamanhos-de-foto-para-passaporte-requisitos-por-pais"
    }
  },
  {
    "slug": "passport-photo-rules-methodology",
    "updatedAt": "2026-05-26",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-rules-methodology",
      "es": "como-verifica-passlens-las-reglas-de-fotos-de-pasaporte-fuentes-o-passport-photo",
      "fr": "comment-passlens-verifie-les-regles-des-photos-de-passeport-sourc-passport-photo",
      "ar": "كيف-يتحقق-passlens-من-قواعد-صور-جواز-السفر-المصادر-الرسمية-والسيا-passport-photo",
      "zh-Hans": "passlens-如何核验护照照片规则-官方来源-编辑政策与更新流程",
      "de": "wie-passlens-passfoto-regeln-pruft-offizielle-quellen-redaktionsr-passport-photo",
      "pt": "como-o-passlens-verifica-as-regras-de-fotos-para-passaporte-fonte-passport-photo"
    }
  },
  {
    "slug": "passport-photo-software-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-software-guide",
      "es": "guia-de-software-para-fotos-de-pasaporte-editores-camaras-recorte-passport-photo",
      "fr": "guide-des-logiciels-de-photo-de-passeport-editeurs-cameras-recadr-passport-photo",
      "ar": "دليل-برامج-صور-جواز-السفر-المحررات-والكاميرات-والقص-والقوالب-والطابعات-والورق",
      "zh-Hans": "护照照片软件指南-编辑器-相机-裁剪工具-模板-打印机与相纸",
      "de": "passfoto-software-guide-editoren-kameras-zuschnitt-vorlagen-drucker-und-papier",
      "pt": "guia-de-software-para-foto-de-passaporte-editores-cameras-recorte-passport-photo"
    }
  },
  {
    "slug": "passport-photo-editor-online-guide",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-editor-online-guide",
      "es": "editor-online-de-fotos-de-pasaporte-que-comparar-antes-de-subir-o-imprimir",
      "fr": "editeur-de-photo-de-passeport-en-ligne-quoi-comparer-avant-de-tel-passport-photo",
      "ar": "محرر-صور-جواز-السفر-عبر-الا-نترنت-ما-الذي-يجب-مقارنته-قبل-الرفع-ا-و-الطباعة",
      "zh-Hans": "在线护照照片编辑器-上传或打印前该比较什么",
      "de": "online-passfoto-editor-was-du-vor-upload-oder-druck-vergleichen-solltest",
      "pt": "editor-online-de-foto-para-passaporte-o-que-comparar-antes-de-enviar-ou-imprimir"
    }
  },
  {
    "slug": "passport-photo-printer-guide",
    "updatedAt": "2026-04-12",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-printer-guide",
      "es": "guia-de-impresoras-para-fotos-de-pasaporte-inyeccion-laser-bandej-passport-photo",
      "fr": "guide-des-imprimantes-pour-photos-de-passeport-jet-dencre-laser-b-passport-photo",
      "ar": "دليل-طابعات-صور-جواز-السفر-نافثة-للحبر-ليزر-ا-دراج-4x6-وا-عدادات-الطباعة-المهمة",
      "zh-Hans": "护照照片打印机指南-喷墨-激光-4x6-托盘与关键打印设置",
      "de": "passfoto-drucker-guide-tintenstrahl-laser-4x6-facher-und-wichtige-passport-photo",
      "pt": "guia-de-impressoras-para-foto-de-passaporte-jato-de-tinta-laser-b-passport-photo"
    }
  },
  {
    "slug": "passport-photo-paper-guide",
    "updatedAt": "2026-05-27",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-paper-guide",
      "es": "guia-de-papel-para-fotos-de-pasaporte-brillo-mate-gramaje-y-manejo-de-impresion",
      "fr": "guide-du-papier-pour-photos-de-passeport-brillant-mat-grammage-et-passport-photo",
      "ar": "دليل-ورق-صور-جواز-السفر-لامع-ا-م-مطفي-وزن-الورق-والتعامل-مع-الطباعة",
      "zh-Hans": "护照照片相纸指南-光面-哑面-纸张克重与打印处理",
      "de": "passfoto-papier-guide-glanzend-vs-matt-papiergewicht-und-druckhandhabung",
      "pt": "guia-de-papel-para-foto-de-passaporte-brilho-matte-gramatura-e-ma-passport-photo"
    }
  },
  {
    "slug": "passport-photo-supplies-checklist",
    "updatedAt": "2026-05-03",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-supplies-checklist",
      "es": "lista-de-suministros-para-fotos-de-pasaporte-impresora-papel-cort-passport-photo",
      "fr": "liste-de-fournitures-pour-photo-de-passeport-imprimante-papier-ma-passport-photo",
      "ar": "قاي-مة-مستلزمات-صورة-جواز-السفر-طابعة-ورق-قاطع-ا-ضاءة-وخلفية",
      "zh-Hans": "护照照片用品清单-打印机-相纸-裁纸刀-灯光与背景",
      "de": "passfoto-zubehor-checkliste-drucker-papier-schneider-licht-und-hintergrund",
      "pt": "lista-de-materiais-para-foto-de-passaporte-impressora-papel-cortador-luz-e-fundo"
    }
  },
  {
    "slug": "camera-lens-guide-for-passport-photos",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "camera-lens-guide-for-passport-photos",
      "es": "mejor-camara-y-objetivo-para-fotos-de-pasaporte-movil-mirrorless-35-camera-lens",
      "fr": "meilleur-appareil-photo-et-objectif-pour-photo-de-passeport-telephon-camera-lens",
      "ar": "ا-فضل-كاميرا-وعدسة-لصور-جواز-السفر-الهاتف-الكاميرا-عديمة-المرا-ة-35-camera-lens",
      "zh-Hans": "护照照片相机和镜头指南-手机-微单-35mm-50mm-与-passlens-流程",
      "de": "beste-kamera-und-bestes-objektiv-fur-passfotos-smartphone-systemkame-camera-lens",
      "pt": "melhor-camera-e-lente-para-fotos-de-passaporte-celular-mirrorless-35-camera-lens"
    }
  },
  {
    "slug": "passport-photo-template-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-template-guide",
      "es": "guia-de-plantillas-para-fotos-de-pasaporte-4x6-a4-letter-lineas-d-passport-photo",
      "fr": "guide-des-modeles-pour-photos-de-passeport-10x15-a4-letter-traits-passport-photo",
      "ar": "دليل-قوالب-صور-جواز-السفر-4x6-وa4-وletter-وخطوط-القص-والتخطيطات-المتعددة",
      "zh-Hans": "护照照片模板指南-4x6-a4-letter-裁切线与多张排版",
      "de": "passfoto-vorlagen-guide-4x6-a4-letter-schnittlinien-und-mehrfachlayouts",
      "pt": "guia-de-modelos-para-foto-de-passaporte-4x6-a4-letter-linhas-de-c-passport-photo"
    }
  },
  {
    "slug": "passport-photo-crop-tool-guide",
    "updatedAt": "2026-05-26",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-crop-tool-guide",
      "es": "guia-de-herramientas-de-recorte-para-fotos-de-pasaporte-tamano-de-passport-photo",
      "fr": "guide-des-outils-de-recadrage-pour-photos-de-passeport-taille-de-passport-photo",
      "ar": "دليل-ا-داة-قص-صور-جواز-السفر-حجم-الرا-س-والا-طار-والتحكم-الدقيق-في-التصدير",
      "zh-Hans": "护照照片裁剪工具指南-头部尺寸-构图与精确导出控制",
      "de": "passfoto-zuschnitts-guide-kopfgroße-bildausschnitt-und-exakte-exportkontrolle",
      "pt": "guia-de-ferramenta-de-recorte-para-foto-de-passaporte-tamanho-da-passport-photo"
    }
  },
  {
    "slug": "how-to-print-passport-photos",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "how-to-print-passport-photos",
      "es": "como-imprimir-fotos-de-pasaporte-en-casa-papel-dpi-y-ajustes-de-impresora",
      "fr": "comment-imprimer-des-photos-de-passeport-a-la-maison-papier-dpi-et-reglages",
      "ar": "كيفية-طباعة-صور-جواز-السفر-في-المنزل-الورق-وdpi-وا-عدادات-الطابعة",
      "zh-Hans": "在家打印护照照-纸张-dpi-与打印设置",
      "de": "passfotos-zu-hause-drucken-papier-dpi-und-druckereinstellungen",
      "pt": "como-imprimir-fotos-de-passaporte-em-casa-papel-dpi-e-configuracoes-da-im-how-to"
    }
  },
  {
    "slug": "2x2-passport-photo-size",
    "updatedAt": "2026-07-03",
    "indexable": true,
    "localizedSlugs": {
      "en": "2x2-passport-photo-size",
      "es": "tamano-de-foto-2x2-para-pasaporte-medidas-americanas-pixeles-y-regl-2x2-passport",
      "fr": "taille-de-photo-passeport-2x2-dimensions-americaines-pixels-et-regl-2x2-passport",
      "ar": "مقاس-صورة-الجواز-2x2-الا-بعاد-الا-مريكية-والبكسلات-وقاعدة-البوصتين",
      "zh-Hans": "2x2-护照照片尺寸-美国护照尺寸-像素和-2-英寸规则",
      "de": "2x2-passfoto-große-amerikanische-passfoto-maße-pixel-und-2-zoll-regeln",
      "pt": "tamanho-2x2-para-foto-de-passaporte-medidas-americanas-pixels-e-reg-2x2-passport"
    }
  },
  {
    "slug": "2x2-photo-maker-online-guide",
    "updatedAt": "2026-07-03",
    "indexable": true,
    "localizedSlugs": {
      "en": "2x2-photo-maker-online-guide",
      "es": "creador-online-de-fotos-2x2-prepara-una-foto-tipo-pasaporte-o-visa-en-2x2-photo",
      "fr": "createur-de-photo-2x2-en-ligne-preparer-une-photo-type-passeport-ou-vi-2x2-photo",
      "ar": "ا-داة-ا-نشاء-صورة-2x2-عبر-الا-نترنت-ا-عداد-صورة-با-سلوب-جواز-السفر-ا-و-2x2-photo",
      "zh-Hans": "在线-2x2-照片制作工具-在浏览器中制作美式护照或签证照片",
      "de": "2x2-fotomacher-online-erstelle-ein-u-s-style-pass-oder-visafoto-im-browser",
      "pt": "criador-online-de-foto-2x2-faca-uma-foto-estilo-passaporte-ou-visto-no-navegador"
    }
  },
  {
    "slug": "2x2-passport-photo-online-free-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "2x2-passport-photo-online-free-guide",
      "es": "foto-de-pasaporte-2x2-online-gratis-recortar-revisar-y-exportar",
      "fr": "photo-de-passeport-2x2-gratuite-en-ligne-recadrer-verifier-et-exporter",
      "ar": "صورة-جواز-سفر-2x2-مجانا-عبر-الا-نترنت-القص-والمراجعة-والتصدير",
      "zh-Hans": "免费在线-2x2-护照照片-裁剪-检查并导出",
      "de": "2x2-passfoto-online-kostenlos-zuschneiden-prufen-und-exportieren",
      "pt": "foto-de-passaporte-2x2-online-gratis-cortar-verificar-e-exportar"
    }
  },
  {
    "slug": "35x45-photo-size-guide",
    "updatedAt": "2026-07-03",
    "indexable": true,
    "localizedSlugs": {
      "en": "35x45-photo-size-guide",
      "es": "guia-del-tamano-35x45-requisitos-para-pasaporte-visa-e-identificacion",
      "fr": "guide-du-format-35x45-exigences-pour-passeport-visa-et-piece-didentite",
      "ar": "دليل-مقاس-35x45-متطلبات-جواز-السفر-والتا-شيرة-والهوية",
      "zh-Hans": "35x45-照片尺寸指南-护照-签证与身份证要求",
      "de": "35x45-fotogroße-anforderungen-fur-pass-visum-und-ausweis",
      "pt": "guia-do-tamanho-35x45-requisitos-para-passaporte-visto-e-identidade"
    }
  },
  {
    "slug": "schengen-visa-photo-guide",
    "updatedAt": "2026-07-06",
    "indexable": true,
    "localizedSlugs": {
      "en": "schengen-visa-photo-guide",
      "es": "requisitos-de-foto-para-visa-schengen-reglas-35x45-mm-normas-oaci-schengen-visa",
      "fr": "exigences-photo-pour-visa-schengen-regles-35x45-mm-normes-oaci-et-schengen-visa",
      "ar": "متطلبات-صورة-تا-شيرة-شنغن-قواعد-35x45-مم-معايير-icao-والفروق-بين-الدول-الا-عضاء",
      "zh-Hans": "申根签证照片要求-35x45-毫米规则-icao-标准与成员国差异",
      "de": "schengen-visafoto-anforderungen-35x45-mm-regeln-icao-standards-und-schengen-visa",
      "pt": "requisitos-de-foto-para-visto-schengen-regras-de-35x45-mm-normas-i-schengen-visa"
    }
  },
  {
    "slug": "50x70-passport-photo-size",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "50x70-passport-photo-size",
      "es": "tamano-50x70-para-pasaporte-requisitos-de-canada-y-visas",
      "fr": "photo-passeport-50x70-exigences-du-passeport-canadien-et-des-visas",
      "ar": "مقاس-صورة-جواز-السفر-50x70-متطلبات-جواز-السفر-الكندي-والتا-شيرات",
      "zh-Hans": "50x70-护照照片尺寸-加拿大护照与签证要求",
      "de": "50x70-passfoto-große-anforderungen-fur-kanada-pass-und-visum",
      "pt": "tamanho-50x70-para-foto-de-passaporte-requisitos-do-passaporte-ca-50x70-passport"
    }
  },
  {
    "slug": "4x6-passport-photo-template",
    "updatedAt": "2026-07-03",
    "indexable": true,
    "localizedSlugs": {
      "en": "4x6-passport-photo-template",
      "es": "plantilla-4x6-para-fotos-de-pasaporte-como-imprimir-2x2-35x45-y-50x-4x6-passport",
      "fr": "modele-10x15-pour-photo-de-passeport-imprimer-du-2x2-35x45-et-50x70-4x6-passport",
      "ar": "قالب-4x6-لصورة-جواز-السفر-كيف-تطبع-صور-2x2-و35x45-و50x70-على-ورق-4x6",
      "zh-Hans": "4x6-护照照片模板-如何在-4x6-相纸上打印-2x2-35x45-和-50x70-照片",
      "de": "4x6-passfoto-vorlage-so-druckst-du-2x2-35x45-und-50x70-fotos-auf-4x6-papier",
      "pt": "modelo-4x6-para-foto-de-passaporte-como-imprimir-2x2-35x45-e-50x70-em-papel-4x6"
    }
  },
  {
    "slug": "a4-passport-photo-template",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "a4-passport-photo-template",
      "es": "plantilla-a4-para-fotos-de-pasaporte-como-imprimir-en-a4-sin-errores-de-escala",
      "fr": "modele-a4-pour-photo-de-passeport-imprimer-sur-a4-sans-erreur-dechelle",
      "ar": "قالب-a4-لصورة-جواز-السفر-كيف-تطبع-على-a4-بدون-ا-خطاء-في-المقياس",
      "zh-Hans": "a4-护照照片模板-如何在-a4-上打印且不发生比例错误",
      "de": "a4-passfoto-vorlage-passfotos-auf-a4-ohne-skalierungsfehler-drucken",
      "pt": "modelo-a4-para-foto-de-passaporte-como-imprimir-em-a4-sem-erros-de-escala"
    }
  },
  {
    "slug": "passport-size-photo-a4-sheet-online-free-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-size-photo-a4-sheet-online-free-guide",
      "es": "foto-tamano-pasaporte-en-hoja-a4-online-gratis-imprimir-sin-errores-de-escala",
      "fr": "photo-format-passeport-sur-feuille-a4-en-ligne-gratuite-imprimer-s-passport-size",
      "ar": "صورة-مقاس-جواز-السفر-على-ورقة-a4-مجانا-عبر-الا-نترنت-طباعة-بلا-ا-خطاء-قياس",
      "zh-Hans": "免费在线-a4-护照尺寸照片排版-避免打印比例错误",
      "de": "passfoto-auf-a4-online-kostenlos-drucken-ohne-skalierungsfehler",
      "pt": "foto-tamanho-passaporte-em-folha-a4-online-gratis-imprimir-sem-erro-de-escala"
    }
  },
  {
    "slug": "letter-passport-photo-template",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "letter-passport-photo-template",
      "es": "plantilla-letter-para-fotos-de-pasaporte-imprime-fotos-en-papel-letter-passport",
      "fr": "modele-letter-pour-photo-de-passeport-imprimer-sur-papier-letter-letter-passport",
      "ar": "قالب-letter-لصورة-جواز-السفر-اطبع-الصور-على-ورق-letter-من-دون-تشويه-الحجم",
      "zh-Hans": "letter-护照照片模板-如何在美式-letter-纸上打印且不扭曲尺寸",
      "de": "letter-passfoto-vorlage-passfotos-auf-us-letter-drucken-ohne-die-letter-passport",
      "pt": "modelo-letter-para-foto-de-passaporte-imprimir-fotos-em-papel-le-letter-passport"
    }
  },
  {
    "slug": "passport-photo-dpi-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-dpi-guide",
      "es": "guia-dpi-para-fotos-de-pasaporte-300-vs-600-dpi-pixeles-tamano-de-passport-photo",
      "fr": "guide-dpi-pour-photo-de-passeport-300-vs-600-dpi-pixels-taille-di-passport-photo",
      "ar": "دليل-dpi-لصور-جواز-السفر-300-مقابل-600-dpi-البكسلات-حجم-الطباعة-وواقع-الرفع",
      "zh-Hans": "护照照片-dpi-指南-300-与-600-dpi-像素-打印尺寸与上传现实",
      "de": "passfoto-dpi-guide-300-gegen-600-dpi-pixel-druckgroße-und-upload-realitat",
      "pt": "guia-de-dpi-para-foto-de-passaporte-300-vs-600-dpi-pixels-tamanho-passport-photo"
    }
  },
  {
    "slug": "passport-photo-size-in-pixels",
    "updatedAt": "2026-07-03",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-size-in-pixels",
      "es": "tamano-de-foto-de-pasaporte-en-pixeles-2x2-35x45-50x70-y-conversiones-a-300-dpi",
      "fr": "taille-de-photo-passeport-en-pixels-2x2-35x45-50x70-et-conversions-300-dpi",
      "ar": "مقاس-صورة-جواز-السفر-بالبكسل-2x2-و35x45-و50x70-وتحويلات-300-dpi",
      "zh-Hans": "护照照片像素尺寸-2x2-35x45-50x70-与-300-dpi-换算",
      "de": "passfoto-große-in-pixeln-2x2-35x45-50x70-und-300-dpi-umrechnung",
      "pt": "tamanho-de-foto-de-passaporte-em-pixels-2x2-35x45-50x70-e-conversoes-em-300-dpi"
    }
  },
  {
    "slug": "2x2-photo-pixels-300-dpi-guide",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "2x2-photo-pixels-300-dpi-guide",
      "es": "pixeles-de-una-foto-2x2-a-300-dpi-600x600-1200x1200-y-reglas-de-subida",
      "fr": "pixels-dune-photo-2x2-a-300-dpi-600x600-1200x1200-et-regles-dupload",
      "ar": "بكسلات-صورة-2x2-عند-300-dpi-600x600-و1200x1200-وقواعد-الرفع",
      "zh-Hans": "2x2-照片在-300-dpi-下的像素-600x600-1200x1200-与上传规则",
      "de": "2x2-foto-pixel-bei-300-dpi-600x600-1200x1200-und-upload-regeln",
      "pt": "pixels-de-foto-2x2-a-300-dpi-600x600-1200x1200-e-regras-de-envio"
    }
  },
  {
    "slug": "passport-photo-background-color-guide",
    "updatedAt": "2026-07-03",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-background-color-guide",
      "es": "guia-de-colores-de-fondo-para-fotos-de-pasaporte-blanco-gris-azul-passport-photo",
      "fr": "guide-des-couleurs-de-fond-pour-photo-passeport-blanc-gris-bleu-e-passport-photo",
      "ar": "دليل-ا-لوان-خلفية-صور-جواز-السفر-ا-بيض-ورمادي-وا-زرق-وما-تسمح-به-كل-دولة",
      "zh-Hans": "护照照片背景颜色指南-白色-灰色-蓝色与各国允许规则",
      "de": "passfoto-hintergrundfarben-weiß-grau-blau-und-was-einzelne-lander-erlauben",
      "pt": "guia-de-cor-de-fundo-para-foto-de-passaporte-branco-cinza-azul-e-passport-photo"
    }
  },
  {
    "slug": "driving-licence-photo-requirements-guide",
    "updatedAt": "2026-05-16",
    "indexable": true,
    "localizedSlugs": {
      "en": "driving-licence-photo-requirements-guide",
      "es": "requisitos-de-foto-para-permiso-de-conducir-paises-estados-y-tamanos-compatibles",
      "fr": "exigences-photo-pour-permis-de-conduire-pays-regions-et-formats-pris-en-charge",
      "ar": "متطلبات-صورة-رخصة-القيادة-البلدان-والولايات-والمقاسات-المدعومة",
      "zh-Hans": "驾照照片要求-支持的国家-地区与尺寸",
      "de": "anforderungen-an-fuhrerscheinfotos-unterstutzte-lander-regionen-und-großen",
      "pt": "requisitos-de-foto-para-carteira-de-motorista-paises-estados-e-t-driving-licence"
    }
  },
  {
    "slug": "driving-licence-photo-id-over-18-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "driving-licence-photo-id-over-18-guide",
      "es": "permiso-de-conducir-como-identificacion-con-foto-para-mayores-de-driving-licence",
      "fr": "permis-de-conduire-comme-piece-didentite-photo-pour-les-plus-de-driving-licence",
      "ar": "رخصة-القيادة-كهوية-مصورة-لا-ثبات-ا-نك-فوق-18-هل-تكفي-البطاقة-البريطانية",
      "zh-Hans": "驾照作为-18-岁以上照片身份证明-英国-photocard-可以吗",
      "de": "fuhrerschein-als-lichtbildausweis-ab-18-reicht-eine-britische-photocard",
      "pt": "carteira-de-motorista-como-documento-com-foto-para-maiores-de-18-driving-licence"
    }
  },
  {
    "slug": "photo-id-requirements-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "photo-id-requirements-guide",
      "es": "requisitos-de-foto-para-documentos-con-foto-guias-por-pais-para-ids-y-licencias",
      "fr": "exigences-photo-pour-piece-didentite-guides-par-pays-pour-cartes-et-permis",
      "ar": "متطلبات-صورة-الهوية-ا-دلة-حسب-البلد-لبطاقات-الهوية-والرخص",
      "zh-Hans": "证件照片要求-各国身份证件与驾照指南",
      "de": "foto-id-anforderungen-landerleitfaden-fur-amtliche-ausweise-und-fuhrerscheine",
      "pt": "requisitos-de-foto-para-documento-com-foto-guias-por-pais-para-ids-e-carteiras"
    }
  },
  {
    "slug": "government-issued-photo-id-guide",
    "updatedAt": "2026-05-26",
    "indexable": true,
    "localizedSlugs": {
      "en": "government-issued-photo-id-guide",
      "es": "documento-oficial-con-foto-que-cuenta-y-que-reglas-de-foto-aplican",
      "fr": "piece-didentite-officielle-avec-photo-ce-qui-compte-et-quelles-government-issued",
      "ar": "الهوية-الحكومية-المزودة-بصورة-ما-الذي-ي-عد-مقبول-ا-وما-القواعد-التي-تنطبق",
      "zh-Hans": "政府签发的带照片身份证明-什么算有效-以及适用哪些照片规则",
      "de": "amtlicher-lichtbildausweis-was-zahlt-und-welche-fotoregeln-gelten",
      "pt": "documento-oficial-com-foto-o-que-conta-e-quais-regras-de-foto-se-aplicam"
    }
  },
  {
    "slug": "how-to-get-a-photo-id-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "how-to-get-a-photo-id-guide",
      "es": "como-conseguir-una-identificacion-con-foto-dmv-pennsylvania-nueva-york-y-how-to",
      "fr": "comment-obtenir-une-piece-didentite-avec-photo-dmv-pennsylvanie-new-york-how-to",
      "ar": "كيفية-الحصول-على-بطاقة-هوية-مزودة-بصورة-dmv-وبنسلفانيا-ونيويورك-وا-ين-تتقدم",
      "zh-Hans": "如何办理带照片身份证件-dmv-宾夕法尼亚-纽约以及办理地点",
      "de": "wie-man-einen-lichtbildausweis-bekommt-dmv-pennsylvania-new-york-und-die-how-to",
      "pt": "como-tirar-um-documento-com-foto-dmv-pensilvania-nova-york-e-onde-solicitar"
    }
  },
  {
    "slug": "photo-id-near-me-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "photo-id-near-me-guide",
      "es": "identificacion-con-foto-cerca-de-mi-dmv-photo-license-centers-cvs-walma-photo-id",
      "fr": "piece-didentite-photo-pres-de-chez-moi-dmv-photo-license-centers-cvs-wa-photo-id",
      "ar": "هوية-مصورة-بالقرب-مني-dmv-ومراكز-الصور-وcvs-وwalmart-وخيارات-الطباعة-السريعة",
      "zh-Hans": "我附近的带照片身份证服务-dmv-拍照中心-cvs-walmart-与快速打印",
      "de": "lichtbildausweis-in-meiner-nahe-dmv-photo-license-center-cvs-walmart-un-photo-id",
      "pt": "documento-com-foto-perto-de-mim-dmv-photo-license-center-cvs-walmart-e-photo-id"
    }
  },
  {
    "slug": "real-id-photo-guide",
    "updatedAt": "2026-04-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "real-id-photo-guide",
      "es": "foto-para-real-id-que-cambia-cuando-toma-la-foto-el-dmv-y-cuando-sigue-s-real-id",
      "fr": "photo-pour-real-id-ce-qui-change-quand-le-dmv-prend-la-photo-et-quand-le-real-id",
      "ar": "صورة-real-id-ما-الذي-يتغير-ومتى-يلتقط-dmv-الصورة-ومتى-يبقى-جواز-السفر-كافي-ا",
      "zh-Hans": "real-id-照片指南-real-id-改变了什么-何时由-dmv-拍照-以及何时护照仍然足够",
      "de": "real-id-foto-was-sich-andert-wann-das-dmv-das-foto-macht-und-wann-der-re-real-id",
      "pt": "foto-para-real-id-o-que-muda-quando-o-dmv-tira-a-foto-e-quando-o-passapo-real-id"
    }
  },
  {
    "slug": "us-state-driver-license-photo-guide",
    "updatedAt": "2026-04-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "us-state-driver-license-photo-guide",
      "es": "reglas-de-foto-para-licencia-identificacion-estatal-y-real-id-en-ee-uu-us-state",
      "fr": "regles-des-photos-de-permis-didentifiant-detat-et-de-real-id-aux-etats-us-state",
      "ar": "قواعد-صور-رخص-القيادة-وبطاقات-الهوية-الحكومية-وreal-id-في-الولايات-المت-us-state",
      "zh-Hans": "美国各州驾照-州身份证与-real-id-照片规则-何时由-dmv-拍照-何时沿用旧照片-以及-passlens-真正能覆盖哪些州流程",
      "de": "us-regeln-fur-fuhrerschein-state-id-und-real-id-fotos-nach-bundesstaat-us-state",
      "pt": "regras-de-foto-para-carteira-de-motorista-documento-estadual-e-real-id-us-state"
    }
  },
  {
    "slug": "id-photo-print-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "id-photo-print-guide",
      "es": "como-imprimir-correctamente-fotos-de-identificacion-tamano-dpi-papel-pl-id-photo",
      "fr": "comment-imprimer-correctement-des-photos-didentite-taille-ppp-papier-mo-id-photo",
      "ar": "كيفية-طباعة-صور-الهوية-بشكل-صحيح-المقاس-وdpi-والورق-والقوالب-ومعالجة-المشكلات",
      "zh-Hans": "如何正确打印证件照-尺寸-dpi-相纸-模板与打印问题排查",
      "de": "id-fotos-richtig-drucken-große-dpi-papier-vorlagen-und-druckfehler-beheben",
      "pt": "como-imprimir-fotos-de-identificacao-corretamente-tamanho-dpi-papel-mod-id-photo"
    }
  },
  {
    "slug": "passport-photo-booth-guide",
    "updatedAt": "2026-05-27",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-booth-guide",
      "es": "guia-de-cabinas-para-fotos-de-pasaporte-boots-max-spielmann-farma-passport-photo",
      "fr": "guide-des-cabines-photo-pour-passeport-boots-max-spielmann-pharma-passport-photo",
      "ar": "دليل-ا-كشاك-صور-جواز-السفر-boots-وmax-spielmann-والصيدليات-والبدا-passport-photo",
      "zh-Hans": "护照照片亭指南-boots-max-spielmann-药房服务与在线替代方案",
      "de": "passfotoautomat-guide-boots-max-spielmann-apotheken-und-online-alternativen",
      "pt": "guia-de-cabines-de-foto-para-passaporte-boots-max-spielmann-farma-passport-photo"
    }
  },
  {
    "slug": "boots-passport-photo-guide",
    "updatedAt": "2026-03-12",
    "indexable": true,
    "localizedSlugs": {
      "en": "boots-passport-photo-guide",
      "es": "boots-passport-photo-cabinas-impresiones-y-cuando-usar-una-alternativa-online",
      "fr": "boots-passport-photo-cabines-tirages-et-quand-utiliser-une-alternative-en-ligne",
      "ar": "boots-passport-photo-الا-كشاك-والمطبوعات-ومتى-تستخدم-بديلا-عبر-الا-نترنت",
      "zh-Hans": "boots-护照照片-照片亭-打印以及何时使用在线替代方案",
      "de": "boots-passport-photo-automaten-ausdrucke-und-wann-sich-eine-onlin-boots-passport",
      "pt": "boots-passport-photo-cabines-impressoes-e-quando-usar-uma-alternativa-online"
    }
  },
  {
    "slug": "walgreens-passport-photo-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "walgreens-passport-photo-guide",
      "es": "walgreens-passport-photo-impresiones-en-tienda-copias-digital-walgreens-passport",
      "fr": "walgreens-passport-photo-tirages-en-magasin-copies-numeriques-walgreens-passport",
      "ar": "walgreens-passport-photo-مطبوعات-المتجر-والنسخ-الرقمية-ومتى-ت-walgreens-passport",
      "zh-Hans": "walgreens-护照照片-门店打印-电子副本以及何时使用在线替代方案",
      "de": "walgreens-passport-photo-ausdrucke-im-laden-digitale-kopien-u-walgreens-passport",
      "pt": "walgreens-passport-photo-impressoes-na-loja-copias-digitais-e-walgreens-passport"
    }
  },
  {
    "slug": "cvs-pharmacy-photo-id-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "cvs-pharmacy-photo-id-guide",
      "es": "cvs-pharmacy-photo-id-fotos-de-pasaporte-impresiones-y-cuando-usar-cvs-pharmacy",
      "fr": "cvs-pharmacy-photo-id-photos-de-passeport-tirages-et-quand-utiliser-cvs-pharmacy",
      "ar": "cvs-pharmacy-photo-id-صور-جواز-السفر-والمطبوعات-ومتى-تستخدم-بديلا-عبر-الا-نترنت",
      "zh-Hans": "cvs-pharmacy-photo-id-护照照片-打印以及何时使用在线替代方案",
      "de": "cvs-pharmacy-photo-id-passfotos-ausdrucke-und-wann-sich-eine-online-cvs-pharmacy",
      "pt": "cvs-pharmacy-photo-id-fotos-de-passaporte-impressoes-e-quando-usar-cvs-pharmacy"
    }
  },
  {
    "slug": "walmart-id-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "walmart-id-photo-guide",
      "es": "walmart-id-photo-fotos-de-pasaporte-impresiones-y-cuando-usar-una-alt-walmart-id",
      "fr": "walmart-id-photo-photos-de-passeport-tirages-et-quand-utiliser-une-al-walmart-id",
      "ar": "walmart-id-photo-صور-جواز-السفر-والمطبوعات-ومتى-تستخدم-بديلا-عبر-الا-نترنت",
      "zh-Hans": "walmart-id-photo-护照照片-打印以及何时使用在线替代方案",
      "de": "walmart-id-photo-passfotos-ausdrucke-und-wann-sich-eine-online-alternative-lohnt",
      "pt": "walmart-id-photo-fotos-de-passaporte-impressoes-e-quando-usar-uma-alt-walmart-id"
    }
  },
  {
    "slug": "rite-aid-passport-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "rite-aid-passport-photo-guide",
      "es": "fotos-de-pasaporte-en-rite-aid-que-comprobar-antes-de-depender-del-most-rite-aid",
      "fr": "photos-de-passeport-chez-rite-aid-quoi-verifier-avant-de-compter-sur-le-rite-aid",
      "ar": "صور-جواز-السفر-في-rite-aid-ما-يجب-التحقق-منه-قبل-الاعتماد-على-مكتب-الصيدلية",
      "zh-Hans": "rite-aid-护照照片-依赖药店柜台前应检查什么",
      "de": "passfotos-bei-rite-aid-was-du-prufen-solltest-bevor-du-dich-auf-den-apo-rite-aid",
      "pt": "fotos-de-passaporte-na-rite-aid-o-que-verificar-antes-de-depender-do-ba-rite-aid"
    }
  },
  {
    "slug": "target-passport-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "target-passport-photo-guide",
      "es": "fotos-de-pasaporte-en-target-target-photo-ez-prints-y-mejores-al-target-passport",
      "fr": "photos-de-passeport-chez-target-target-photo-ez-prints-et-meille-target-passport",
      "ar": "صور-جواز-السفر-في-target-target-photo-وez-prints-وبداي-ل-ا-فضل-في-اليوم-نفسه",
      "zh-Hans": "target-护照照片-target-photo-ez-prints-和更好的当日替代方案",
      "de": "passfotos-bei-target-target-photo-ez-prints-und-bessere-alternat-target-passport",
      "pt": "fotos-de-passaporte-na-target-target-photo-ez-prints-e-melhores-target-passport"
    }
  },
  {
    "slug": "ups-passport-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "ups-passport-photo-guide",
      "es": "fotos-de-pasaporte-en-ups-servicio-de-the-ups-store-costes-que-revi-ups-passport",
      "fr": "photos-de-passeport-ups-service-the-ups-store-couts-a-verifier-et-m-ups-passport",
      "ar": "صور-جواز-السفر-لدى-ups-خدمة-the-ups-store-والتكاليف-التي-يجب-التحقق-ups-passport",
      "zh-Hans": "ups-护照照片-the-ups-store-照片服务-需核对的费用和更稳妥的准备流程",
      "de": "ups-passfotos-the-ups-store-zu-prufende-kosten-und-bessere-vorbereitung",
      "pt": "fotos-de-passaporte-na-ups-servico-the-ups-store-custos-a-conferir-ups-passport"
    }
  },
  {
    "slug": "max-spielmann-id-photo-booth-guide",
    "updatedAt": "2026-05-27",
    "indexable": true,
    "localizedSlugs": {
      "en": "max-spielmann-id-photo-booth-guide",
      "es": "max-spielmann-id-photo-booth-fotos-de-pasaporte-codigos-digitales-max-spielmann",
      "fr": "max-spielmann-id-photo-booth-photos-de-passeport-codes-numeriques-max-spielmann",
      "ar": "max-spielmann-id-photo-booth-صور-جواز-السفر-والرموز-الرقمية-والبدا-max-spielmann",
      "zh-Hans": "max-spielmann-id-photo-booth-护照照片-电子代码与在线替代方案",
      "de": "max-spielmann-id-photo-booth-passfotos-digitale-codes-und-online-alternativen",
      "pt": "max-spielmann-id-photo-booth-fotos-de-passaporte-codigos-digitais-max-spielmann"
    }
  },
  {
    "slug": "automatic-background-removal-passport-photo-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "automatic-background-removal-passport-photo-guide",
      "es": "eliminacion-automatica-de-fondo-para-fotos-de-pasaporte-lim-automatic-background",
      "fr": "suppression-automatique-de-larriere-plan-pour-les-photos-de-automatic-background",
      "ar": "الا-زالة-التلقاي-ية-للخلفية-في-صور-جواز-السفر-تنظيف-بالذكاء-automatic-background",
      "zh-Hans": "护照照片自动去背景-ai-清理-白底以及需要检查的内容",
      "de": "automatische-hintergrundentfernung-fur-passfotos-ki-bereini-automatic-background",
      "pt": "remocao-automatica-de-fundo-para-fotos-de-passaporte-limpez-automatic-background"
    }
  },
  {
    "slug": "passport-photo-background-remover-online-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-background-remover-online-guide",
      "es": "eliminador-online-de-fondo-para-foto-de-pasaporte-blanco-gris-azu-passport-photo",
      "fr": "suppresseur-darriere-plan-pour-photo-de-passeport-en-ligne-blanc-passport-photo",
      "ar": "ا-داة-ا-زالة-خلفية-صورة-جواز-السفر-عبر-الا-نترنت-الا-بيض-والرمادي-passport-photo",
      "zh-Hans": "在线护照照片去背景工具-白底-灰底-蓝底与清晰的清理选择",
      "de": "passfoto-hintergrund-online-entfernen-weiß-grau-blau-und-klare-be-passport-photo",
      "pt": "removedor-de-fundo-de-foto-para-passaporte-online-branco-cinza-az-passport-photo"
    }
  },
  {
    "slug": "face-adjustment-passport-photo-guide",
    "updatedAt": "2026-05-26",
    "indexable": true,
    "localizedSlugs": {
      "en": "face-adjustment-passport-photo-guide",
      "es": "ajuste-facial-para-foto-de-pasaporte-posicion-con-ia-tamano-de-cabeza-y-auto-fit",
      "fr": "ajustement-du-visage-pour-photo-de-passeport-positionnement-ia-t-face-adjustment",
      "ar": "ضبط-الوجه-في-صورة-جواز-السفر-تموضع-الوجه-بالذكاء-الاصطناعي-حجم-ا-face-adjustment",
      "zh-Hans": "护照照片面部调整-ai-面部定位-头部尺寸与自动适配",
      "de": "passfoto-gesichtsanpassung-ki-gesichtspositionierung-kopfgroße-und-auto-fit",
      "pt": "ajuste-facial-em-foto-de-passaporte-posicionamento-com-ia-tamanh-face-adjustment"
    }
  },
  {
    "slug": "passport-photo-maker-online-free",
    "updatedAt": "2026-06-05",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-maker-online-free",
      "es": "creador-gratis-de-fotos-de-pasaporte-online-haz-fotos-tamano-pasa-passport-photo",
      "fr": "createur-gratuit-de-photo-de-passeport-en-ligne-realisez-vos-phot-passport-photo",
      "ar": "صانع-صور-جواز-السفر-المجاني-عبر-الا-نترنت-ا-نشي-صور-مقاس-جواز-السفر-في-المتصفح",
      "zh-Hans": "免费在线护照照片制作工具-在浏览器中生成护照尺寸照片",
      "de": "kostenloser-online-passfoto-maker-passbilder-direkt-im-browser-erstellen",
      "pt": "criador-gratis-de-foto-para-passaporte-online-faca-fotos-em-taman-passport-photo"
    }
  },
  {
    "slug": "passport-photo-local-processing-privacy-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-local-processing-privacy-guide",
      "es": "creador-privado-de-fotos-de-pasaporte-procesamiento-local-sin-reg-passport-photo",
      "fr": "createur-prive-de-photo-de-passeport-traitement-local-sans-inscri-passport-photo",
      "ar": "صانع-صور-جواز-سفر-خاص-معالجة-محلية-بلا-تسجيل-وخيار-خادم-واضح",
      "zh-Hans": "私密护照照片制作工具-本地处理-无需注册与清晰的处理选择",
      "de": "privater-passfoto-maker-lokale-verarbeitung-keine-anmeldung-und-k-passport-photo",
      "pt": "criador-privado-de-foto-para-passaporte-processamento-local-sem-c-passport-photo"
    }
  },
  {
    "slug": "passport-photo-clean-export-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-clean-export-guide",
      "es": "exportacion-limpia-de-foto-de-pasaporte-sin-marca-de-agua-tamano-passport-photo",
      "fr": "export-propre-de-photo-de-passeport-sans-filigrane-bonne-taille-e-passport-photo",
      "ar": "دليل-تصدير-صورة-جواز-سفر-نظيفة-بلا-علامة-ماي-ية-مقاس-صحيح-وتنزيلات-جاهزة-للطباعة",
      "zh-Hans": "护照照片干净导出指南-无水印-尺寸正确-可直接打印下载",
      "de": "sauberer-passfoto-export-kein-wasserzeichen-richtige-große-und-dr-passport-photo",
      "pt": "exportacao-limpa-de-foto-para-passaporte-sem-marca-dagua-tamanho-passport-photo"
    }
  },
  {
    "slug": "convert-photo-to-passport-photo-guide",
    "updatedAt": "2026-07-06",
    "indexable": true,
    "localizedSlugs": {
      "en": "convert-photo-to-passport-photo-guide",
      "es": "convierte-una-foto-a-tamano-pasaporte-online-recorte-fondo-y-guia-de-tamano",
      "fr": "convertir-une-photo-au-format-passeport-en-ligne-recadrage-fond-et-convert-photo",
      "ar": "حو-ل-صورة-ا-لى-مقاس-جواز-سفر-عبر-الا-نترنت-القص-والخلفية-ودليل-المقاس",
      "zh-Hans": "在线把普通照片转换为护照照片-裁剪-背景与尺寸指南",
      "de": "foto-online-in-passbild-umwandeln-zuschnitt-hintergrund-und-großenleitfaden",
      "pt": "converta-uma-foto-para-tamanho-passaporte-online-recorte-fundo-e-guia-de-medidas"
    }
  },
  {
    "slug": "passport-photo-app-guide",
    "updatedAt": "2026-05-26",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-app-guide",
      "es": "guia-de-apps-para-fotos-de-pasaporte-que-usar-en-iphone-android-o-la-web",
      "fr": "guide-des-applications-photo-pour-passeport-quoi-utiliser-sur-iph-passport-photo",
      "ar": "دليل-تطبيقات-صور-جواز-السفر-ماذا-تستخدم-على-iphone-ا-و-android-ا-و-الويب",
      "zh-Hans": "护照照片-app-指南-iphone-android-与网页端该用什么",
      "de": "passfoto-app-guide-was-du-auf-iphone-android-oder-im-web-nutzen-solltest",
      "pt": "guia-de-app-para-foto-de-passaporte-o-que-usar-no-iphone-android-ou-na-web"
    }
  },
  {
    "slug": "id-photo-maker-online-guide",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "id-photo-maker-online-guide",
      "es": "creador-online-de-fotos-biometricas-fotos-para-pasaporte-visa-e-identificacion",
      "fr": "createur-de-photo-biometrique-en-ligne-photos-pour-passeport-visa-et-pi-id-photo",
      "ar": "صانع-الصور-البيومترية-عبر-الا-نترنت-صور-لجوازات-السفر-والتا-شيرات-وبطاقات-الهوية",
      "zh-Hans": "在线生物识别照片制作工具-护照-签证与身份证照片",
      "de": "biometrischer-foto-maker-online-id-fotos-fur-pass-visum-und-ausweise",
      "pt": "criador-online-de-foto-biometrica-fotos-para-passaporte-visto-e-identificacao"
    }
  },
  {
    "slug": "passport-photo-checker-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-checker-guide",
      "es": "comprobador-de-fotos-para-pasaporte-como-validar-una-foto-antes-d-passport-photo",
      "fr": "verificateur-de-photo-de-passeport-comment-valider-une-photo-avan-passport-photo",
      "ar": "مدقق-صور-جواز-السفر-كيف-تتحقق-من-الصورة-قبل-الرفع-ا-و-الطباعة",
      "zh-Hans": "护照照片检查器-提交或打印前如何检查护照或签证照片",
      "de": "passfoto-prufer-so-validierst-du-ein-pass-oder-visafoto-vor-upload-oder-druck",
      "pt": "verificador-de-foto-para-passaporte-como-validar-a-foto-antes-de-passport-photo"
    }
  },
  {
    "slug": "passport-photo-validator-online-guide",
    "updatedAt": "2026-06-05",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-validator-online-guide",
      "es": "validador-online-de-fotos-para-pasaporte-como-revisar-una-foto-an-passport-photo",
      "fr": "validateur-de-photo-de-passeport-en-ligne-comment-verifier-une-ph-passport-photo",
      "ar": "مدقق-صور-جواز-السفر-عبر-الا-نترنت-كيف-تراجع-الصورة-قبل-الا-رسال-ا-و-الطباعة",
      "zh-Hans": "在线护照照片验证器-提交或打印前如何检查护照照片",
      "de": "online-passfoto-validator-so-prufst-du-ein-passfoto-vor-einreichen-oder-druck",
      "pt": "validador-online-de-foto-para-passaporte-como-revisar-a-foto-ante-passport-photo"
    }
  },
  {
    "slug": "acceptable-passport-photos-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "acceptable-passport-photos-guide",
      "es": "fotos-de-pasaporte-aceptables-que-hace-que-una-foto-pase-antes-de-enviarla",
      "fr": "photos-de-passeport-acceptables-ce-qui-permet-a-une-photo-de-passer-avant-lenvoi",
      "ar": "صور-جواز-السفر-المقبولة-ما-الذي-يجعل-الصورة-قابلة-للقبول-قبل-الا-رسال",
      "zh-Hans": "可接受的护照照片-提交前什么样的照片更容易通过",
      "de": "akzeptable-passfotos-woran-du-erkennst-dass-ein-foto-vor-dem-acceptable-passport",
      "pt": "fotos-de-passaporte-aceitaveis-o-que-faz-uma-foto-passar-antes-do-envio"
    }
  },
  {
    "slug": "acceptable-passport-photo-examples-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "acceptable-passport-photo-examples-guide",
      "es": "ejemplos-de-fotos-de-pasaporte-aceptables-que-revisar-antes-de-enviar",
      "fr": "exemples-de-photos-de-passeport-acceptables-quoi-verifier-avant-lenvoi",
      "ar": "ا-مثلة-على-صور-جواز-السفر-المقبولة-ما-الذي-تفحصه-قبل-الا-رسال",
      "zh-Hans": "可接受的护照照片示例-提交前应检查什么",
      "de": "beispiele-fur-akzeptable-passfotos-was-du-vor-dem-einreichen-prufen-solltest",
      "pt": "exemplos-de-fotos-de-passaporte-aceitaveis-o-que-revisar-antes-do-envio"
    }
  },
  {
    "slug": "visa-photo-maker-online-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "visa-photo-maker-online-guide",
      "es": "creador-online-de-fotos-para-visa-flujos-35x45-2x2-y-subidas-digitales",
      "fr": "createur-de-photo-de-visa-en-ligne-workflows-35x45-2x2-et-uploads-numeriques",
      "ar": "ا-داة-ا-نشاء-صور-التا-شيرة-عبر-الا-نترنت-مسارات-35x45-و2x2-والرفع-الرقمي",
      "zh-Hans": "在线签证照片制作工具-35x45-2x2-与数字上传流程",
      "de": "visafoto-online-erstellen-35x45-2x2-und-digitale-upload-workflows",
      "pt": "criador-online-de-foto-para-visto-fluxos-35x45-2x2-e-uploads-digitais"
    }
  },
  {
    "slug": "work-permit-photo-size-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "work-permit-photo-size-guide",
      "es": "tamano-de-foto-para-permiso-de-trabajo-subidas-de-visa-tarjetas-de-r-work-permit",
      "fr": "taille-de-photo-pour-permis-de-travail-televersements-visa-cartes-de-work-permit",
      "ar": "مقاس-صورة-تصريح-العمل-رفع-صور-التا-شيرة-وبطاقات-الا-قامة-وتصاريح-العمل",
      "zh-Hans": "工作许可照片尺寸指南-签证上传-居留卡和就业许可照片",
      "de": "fotoformat-fur-arbeitserlaubnisse-visa-uploads-aufenthaltstitel-und-work-permit",
      "pt": "tamanho-de-foto-para-permissao-de-trabalho-uploads-de-visto-cartoes-work-permit"
    }
  },
  {
    "slug": "residence-permit-photo-requirements-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "residence-permit-photo-requirements-guide",
      "es": "requisitos-de-foto-para-permiso-de-residencia-fotos-biometricas-residence-permit",
      "fr": "exigences-photo-pour-permis-de-sejour-photos-biometriques-regle-residence-permit",
      "ar": "متطلبات-صورة-تصريح-الا-قامة-صور-البطاقات-البيومترية-وقواعد-35x45-ومسارات-الرفع",
      "zh-Hans": "居留许可照片要求-生物识别卡照片-35x45-规则和上传路径",
      "de": "fotoanforderungen-fur-aufenthaltstitel-biometrische-kartenfotos-residence-permit",
      "pt": "requisitos-de-foto-para-permissao-de-residencia-fotos-biometric-residence-permit"
    }
  },
  {
    "slug": "uscis-photo-requirements-2x2-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "uscis-photo-requirements-2x2-guide",
      "es": "requisitos-de-foto-uscis-2x2-green-card-ead-y-fotos-migratorias-tipo-pasaporte",
      "fr": "exigences-photo-uscis-2x2-carte-verte-ead-et-photos-dimmigration-type-passeport",
      "ar": "متطلبات-صورة-uscis-مقاس-2x2-البطاقة-الخضراء-وead-وصور-الهجرة-بنمط-جواز-السفر",
      "zh-Hans": "uscis-2x2-照片要求-绿卡-ead-与移民用护照式照片",
      "de": "uscis-fotoanforderungen-2x2-green-card-ead-und-passfoto-ahnliche-ein-uscis-photo",
      "pt": "requisitos-de-foto-uscis-2x2-green-card-ead-e-fotos-migratorias-esti-uscis-photo"
    }
  },
  {
    "slug": "green-card-photo-requirements-guide",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "green-card-photo-requirements-guide",
      "es": "green-card-photo-requirements-uscis-2x2-passport-style-photos-i-485-i-green-card",
      "fr": "green-card-photo-requirements-uscis-2x2-passport-style-photos-i-485-i-green-card",
      "ar": "green-card-photo-requirements-uscis-2x2-passport-style-photos-i-485-i-green-card",
      "zh-Hans": "green-card-photo-requirements-uscis-2x2-passport-style-photos-i-485-i-green-card",
      "de": "green-card-photo-requirements-uscis-2x2-passport-style-photos-i-485-i-green-card",
      "pt": "green-card-photo-requirements-uscis-2x2-passport-style-photos-i-485-i-green-card"
    }
  },
  {
    "slug": "ead-photo-requirements-guide",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "ead-photo-requirements-guide",
      "es": "ead-photo-requirements-uscis-i-765-passport-style-photo-checks-2x2-siz-ead-photo",
      "fr": "ead-photo-requirements-uscis-i-765-passport-style-photo-checks-2x2-siz-ead-photo",
      "ar": "ead-photo-requirements-uscis-i-765-passport-style-photo-checks-2x2-siz-ead-photo",
      "zh-Hans": "ead-photo-requirements-uscis-i-765-passport-style-photo-checks-2x2-siz-ead-photo",
      "de": "ead-photo-requirements-uscis-i-765-passport-style-photo-checks-2x2-siz-ead-photo",
      "pt": "ead-photo-requirements-uscis-i-765-passport-style-photo-checks-2x2-siz-ead-photo"
    }
  },
  {
    "slug": "canada-visa-photo-requirements",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "canada-visa-photo-requirements",
      "es": "canada-visa-photo-requirements-trv-photo-size-biometrics-warning-and-canada-visa",
      "fr": "canada-visa-photo-requirements-trv-photo-size-biometrics-warning-and-canada-visa",
      "ar": "canada-visa-photo-requirements-trv-photo-size-biometrics-warning-and-canada-visa",
      "zh-Hans": "canada-visa-photo-requirements-trv-photo-size-biometrics-warning-and-canada-visa",
      "de": "canada-visa-photo-requirements-trv-photo-size-biometrics-warning-and-canada-visa",
      "pt": "canada-visa-photo-requirements-trv-photo-size-biometrics-warning-and-canada-visa"
    }
  },
  {
    "slug": "student-id-photo-upload-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "student-id-photo-upload-guide",
      "es": "guia-para-subir-foto-de-carnet-estudiantil-tamano-fondo-y-controles-de-rechazo",
      "fr": "guide-denvoi-de-photo-pour-carte-etudiante-taille-fond-et-causes-de-rejet",
      "ar": "دليل-رفع-صورة-بطاقة-الطالب-المقاس-والخلفية-وا-سباب-الرفض",
      "zh-Hans": "学生证照片上传指南-校园卡尺寸-背景和拒收检查",
      "de": "upload-guide-fur-studentenausweisfotos-große-hintergrund-und-ablehnungsgrunde",
      "pt": "guia-de-upload-de-foto-para-carteirinha-estudantil-tamanho-fundo-e-mo-student-id"
    }
  },
  {
    "slug": "online-passport-renewal-photo-upload-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "online-passport-renewal-photo-upload-guide",
      "es": "guia-para-subir-foto-en-la-renovacion-online-de-pasaporte-archiv-online-passport",
      "fr": "guide-denvoi-de-photo-pour-renouvellement-de-passeport-en-ligne-online-passport",
      "ar": "دليل-رفع-صورة-تجديد-جواز-السفر-عبر-الا-نترنت-الملف-الرقمي-وفحوص-online-passport",
      "zh-Hans": "在线护照续办照片上传指南-数字文件规则-拒收检查和打印备份",
      "de": "foto-upload-bei-online-passverlangerung-digitale-datei-ablehnung-online-passport",
      "pt": "guia-de-upload-de-foto-para-renovacao-online-de-passaporte-arqui-online-passport"
    }
  },
  {
    "slug": "china-visa-photo-requirements-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "china-visa-photo-requirements-guide",
      "es": "requisitos-de-foto-para-visa-de-china-impresiones-33x48-mm-subidas-di-china-visa",
      "fr": "exigences-photo-pour-visa-chine-tirages-33x48-mm-televersements-numer-china-visa",
      "ar": "متطلبات-صورة-تا-شيرة-الصين-مطبوعات-33x48-مم-والرفع-الرقمي-وفحوص-cova",
      "zh-Hans": "中国签证照片要求-33x48-毫米纸质照片-数字上传和-cova-检查",
      "de": "fotoanforderungen-fur-china-visum-33x48-mm-abzuge-digitale-uploads-un-china-visa",
      "pt": "requisitos-de-foto-para-visto-da-china-impressoes-33x48-mm-uploads-di-china-visa"
    }
  },
  {
    "slug": "us-citizenship-photo-requirements-guide",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "us-citizenship-photo-requirements-guide",
      "es": "requisitos-de-foto-para-ciudadania-estadounidense-n-400-n-600-fot-us-citizenship",
      "fr": "exigences-photo-pour-citoyennete-americaine-n-400-n-600-photos-2x-us-citizenship",
      "ar": "متطلبات-صورة-الجنسية-الا-مريكية-n-400-وn-600-وصور-2x2-وملاحظات-البصمات-الحيوية",
      "zh-Hans": "美国入籍照片要求-n-400-n-600-2x2-照片和生物识别注意事项",
      "de": "fotoanforderungen-fur-us-staatsburgerschaft-n-400-n-600-2x2-fotos-us-citizenship",
      "pt": "requisitos-de-foto-para-cidadania-dos-eua-n-400-n-600-fotos-2x2-e-us-citizenship"
    }
  },
  {
    "slug": "china-passport-photo-requirements-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "china-passport-photo-requirements-guide",
      "es": "china-passport-photo-requirements-33x48-mm-size-white-background-china-passport",
      "fr": "china-passport-photo-requirements-33x48-mm-size-white-background-china-passport",
      "ar": "china-passport-photo-requirements-33x48-mm-size-white-background-china-passport",
      "zh-Hans": "china-passport-photo-requirements-33x48-mm-size-white-background-china-passport",
      "de": "china-passport-photo-requirements-33x48-mm-size-white-background-china-passport",
      "pt": "china-passport-photo-requirements-33x48-mm-size-white-background-china-passport"
    }
  },
  {
    "slug": "visa-photo-size-by-country-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "visa-photo-size-by-country-guide",
      "es": "tamano-de-foto-para-visa-por-pais-2x2-35x45-33x48-y-reglas-de-carga-digital",
      "fr": "taille-de-photo-de-visa-par-pays-2x2-35x45-33x48-et-regles-de-depot-numerique",
      "ar": "مقاس-صورة-التا-شيرة-حسب-البلد-2x2-و35x45-و33x48-وقواعد-الرفع-الرقمي",
      "zh-Hans": "各国签证照片尺寸-2x2-35x45-33x48-和数字上传规则",
      "de": "visafoto-große-nach-land-2x2-35x45-33x48-und-regeln-fur-digitale-uploads",
      "pt": "tamanho-de-foto-para-visto-por-pais-2x2-35x45-33x48-e-regras-de-upload-digital"
    }
  },
  {
    "slug": "uk-visa-photo-digital-requirements",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "uk-visa-photo-digital-requirements",
      "es": "requisitos-de-foto-para-visa-del-reino-unido-reglas-digitales-minimo-600-uk-visa",
      "fr": "exigences-photo-pour-visa-royaume-uni-regles-numeriques-minimum-600x750-uk-visa",
      "ar": "متطلبات-صورة-تا-شيرة-المملكة-المتحدة-قواعد-الرفع-الرقمي-والحد-الا-دنى-60-uk-visa",
      "zh-Hans": "英国签证照片要求-数字上传规则-最低-600x750-jpg-png-和-ukvi-检查",
      "de": "fotoanforderungen-fur-uk-visum-digitale-regeln-mindestens-600x750-jpg-pn-uk-visa",
      "pt": "requisitos-de-foto-para-visto-do-reino-unido-regras-digitais-minimo-600x-uk-visa"
    }
  },
  {
    "slug": "india-evisa-photo-requirements",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "india-evisa-photo-requirements",
      "es": "requisitos-de-foto-para-evisa-de-india-jpeg-cuadrado-10-kb-1-mb-y-re-india-evisa",
      "fr": "exigences-photo-pour-evisa-inde-jpeg-carre-10-kb-1-mb-et-regles-de-fond",
      "ar": "متطلبات-صورة-evisa-للهند-jpeg-مربع-و10-kb-1-mb-وقواعد-الخلفية",
      "zh-Hans": "印度-evisa-照片要求-正方形-jpeg-10-kb-1-mb-和背景规则",
      "de": "fotoanforderungen-fur-indien-evisa-quadratisches-jpeg-10-kb-1-mb-und-india-evisa",
      "pt": "requisitos-de-foto-para-evisa-da-india-jpeg-quadrado-10-kb-1-mb-e-re-india-evisa"
    }
  },
  {
    "slug": "india-visa-photo-requirements-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "india-visa-photo-requirements-guide",
      "es": "india-visa-photo-requirements-evisa-square-jpegs-paper-visa-photos-an-india-visa",
      "fr": "india-visa-photo-requirements-evisa-square-jpegs-paper-visa-photos-an-india-visa",
      "ar": "india-visa-photo-requirements-evisa-square-jpegs-paper-visa-photos-an-india-visa",
      "zh-Hans": "india-visa-photo-requirements-evisa-square-jpegs-paper-visa-photos-an-india-visa",
      "de": "india-visa-photo-requirements-evisa-square-jpegs-paper-visa-photos-an-india-visa",
      "pt": "india-visa-photo-requirements-evisa-square-jpegs-paper-visa-photos-an-india-visa"
    }
  },
  {
    "slug": "saudi-evisa-photo-requirements-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "saudi-evisa-photo-requirements-guide",
      "es": "saudi-evisa-photo-requirements-200x200-upload-5-100-kb-file-size-and-saudi-evisa",
      "fr": "saudi-evisa-photo-requirements-200x200-upload-5-100-kb-file-size-and-saudi-evisa",
      "ar": "saudi-evisa-photo-requirements-200x200-upload-5-100-kb-file-size-and-saudi-evisa",
      "zh-Hans": "saudi-evisa-photo-requirements-200x200-upload-5-100-kb-file-size-and-saudi-evisa",
      "de": "saudi-evisa-photo-requirements-200x200-upload-5-100-kb-file-size-and-saudi-evisa",
      "pt": "saudi-evisa-photo-requirements-200x200-upload-5-100-kb-file-size-and-saudi-evisa"
    }
  },
  {
    "slug": "uae-visa-photo-requirements-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "uae-visa-photo-requirements-guide",
      "es": "uae-visa-photo-requirements-passport-style-photo-checks-white-backgroun-uae-visa",
      "fr": "uae-visa-photo-requirements-passport-style-photo-checks-white-backgroun-uae-visa",
      "ar": "uae-visa-photo-requirements-passport-style-photo-checks-white-backgroun-uae-visa",
      "zh-Hans": "uae-visa-photo-requirements-passport-style-photo-checks-white-backgroun-uae-visa",
      "de": "uae-visa-photo-requirements-passport-style-photo-checks-white-backgroun-uae-visa",
      "pt": "uae-visa-photo-requirements-passport-style-photo-checks-white-backgroun-uae-visa"
    }
  },
  {
    "slug": "russian-visa-photo-requirements-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "russian-visa-photo-requirements-guide",
      "es": "russian-visa-photo-requirements-3-5x4-5-cm-printed-photo-mfa-form-a-russian-visa",
      "fr": "russian-visa-photo-requirements-3-5x4-5-cm-printed-photo-mfa-form-a-russian-visa",
      "ar": "russian-visa-photo-requirements-3-5x4-5-cm-printed-photo-mfa-form-a-russian-visa",
      "zh-Hans": "russian-visa-photo-requirements-3-5x4-5-cm-printed-photo-mfa-form-a-russian-visa",
      "de": "russian-visa-photo-requirements-3-5x4-5-cm-printed-photo-mfa-form-a-russian-visa",
      "pt": "russian-visa-photo-requirements-3-5x4-5-cm-printed-photo-mfa-form-a-russian-visa"
    }
  },
  {
    "slug": "canada-pr-digital-photo-requirements",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "canada-pr-digital-photo-requirements",
      "es": "requisitos-de-foto-digital-para-residencia-permanente-de-canada-minimo-canada-pr",
      "fr": "exigences-photo-numerique-pour-residence-permanente-canada-minimum-715-canada-pr",
      "ar": "متطلبات-الصورة-الرقمية-للا-قامة-الداي-مة-في-كندا-حد-ا-دنى-715x1000-و42-canada-pr",
      "zh-Hans": "加拿大永久居民数字照片要求-最低-715x1000-420-kb-4-mb-和-ircc-规则",
      "de": "digitale-fotoanforderungen-fur-kanada-pr-mindestens-715x1000-420-kb-4-canada-pr",
      "pt": "requisitos-de-foto-digital-para-residencia-permanente-no-canada-minimo-canada-pr"
    }
  },
  {
    "slug": "france-visa-photo-requirements",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "france-visa-photo-requirements",
      "es": "requisitos-de-foto-para-visa-de-francia-tamano-schengen-reglas-franc-france-visa",
      "fr": "exigences-photo-pour-visa-france-format-schengen-regles-france-visas-france-visa",
      "ar": "متطلبات-صورة-تا-شيرة-فرنسا-مقاس-شنغن-وقواعد-france-visas-وتحضير-35x45",
      "zh-Hans": "法国签证照片要求-申根照片尺寸-france-visas-质量规则和-35x45-准备",
      "de": "fotoanforderungen-fur-frankreich-visum-schengen-format-france-visas-france-visa",
      "pt": "requisitos-de-foto-para-visto-da-franca-tamanho-schengen-regras-fran-france-visa"
    }
  },
  {
    "slug": "germany-visa-photo-requirements",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "germany-visa-photo-requirements",
      "es": "requisitos-de-foto-para-visa-de-alemania-foto-biometrica-35x45-mm-y-germany-visa",
      "fr": "exigences-photo-pour-visa-allemagne-photo-biometrique-allemande-35x-germany-visa",
      "ar": "متطلبات-صورة-تا-شيرة-ا-لمانيا-صورة-بيومترية-35x45-مم-وفحوص-شنغن",
      "zh-Hans": "德国签证照片要求-德国生物识别-35x45-毫米签证照片和申根检查",
      "de": "fotoanforderungen-fur-deutschland-visum-biometrisches-35x45-mm-visa-germany-visa",
      "pt": "requisitos-de-foto-para-visto-da-alemanha-foto-biometrica-35x45-mm-germany-visa"
    }
  },
  {
    "slug": "italy-visa-photo-requirements",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "italy-visa-photo-requirements",
      "es": "requisitos-de-foto-para-visa-de-italia-reglas-schengen-35x45-controle-italy-visa",
      "fr": "exigences-photo-pour-visa-italie-regles-schengen-35x45-controles-foto-italy-visa",
      "ar": "متطلبات-صورة-تا-شيرة-ا-يطاليا-قواعد-شنغن-35x45-وفحوص-fototessera-والت-italy-visa",
      "zh-Hans": "意大利签证照片要求-申根-35x45-规则-fototessera-检查和打印准备",
      "de": "fotoanforderungen-fur-italien-visum-schengen-35x45-fototessera-prufun-italy-visa",
      "pt": "requisitos-de-foto-para-visto-da-italia-regras-schengen-35x45-checage-italy-visa"
    }
  },
  {
    "slug": "spain-visa-photo-requirements",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "spain-visa-photo-requirements",
      "es": "requisitos-de-foto-para-visa-de-espana-controles-schengen-35x45-consu-spain-visa",
      "fr": "exigences-photo-pour-visa-espagne-controles-schengen-35x45-consulat-e-spain-visa",
      "ar": "متطلبات-صورة-تا-شيرة-ا-سبانيا-فحوص-شنغن-35x45-وقواعد-القنصلية-الا-سبا-spain-visa",
      "zh-Hans": "西班牙签证照片要求-申根-35x45-检查-西班牙领事馆规则和打印准备",
      "de": "fotoanforderungen-fur-spanien-visum-schengen-35x45-spanische-konsulat-spain-visa",
      "pt": "requisitos-de-foto-para-visto-da-espanha-checagens-schengen-35x45-con-spain-visa"
    }
  },
  {
    "slug": "netherlands-visa-photo-requirements",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "netherlands-visa-photo-requirements",
      "es": "requisitos-de-foto-para-visa-de-paises-bajos-reglas-neerlandesa-netherlands-visa",
      "fr": "exigences-photo-pour-visa-pays-bas-regles-neerlandaises-35x45-p-netherlands-visa",
      "ar": "متطلبات-صورة-تا-شيرة-هولندا-قواعد-35x45-الهولندية-لمسارات-شنغن-وmvv",
      "zh-Hans": "荷兰签证照片要求-申根和-mvv-路线的荷兰-35x45-规则",
      "de": "fotoanforderungen-fur-niederlande-visum-niederlandische-35x45-r-netherlands-visa",
      "pt": "requisitos-de-foto-para-visto-dos-paises-baixos-regras-neerland-netherlands-visa"
    }
  },
  {
    "slug": "visa-photo-upload-failed-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "visa-photo-upload-failed-guide",
      "es": "fallo-la-subida-de-la-foto-de-visa-soluciones-para-ds-160-ukvi-evisa-visa-photo",
      "fr": "echec-denvoi-de-photo-de-visa-depannage-pour-ds-160-ukvi-evisa-inde-c-visa-photo",
      "ar": "فشل-رفع-صورة-التا-شيرة-حلول-لـ-ds-160-وukvi-وevisa-الهند-وكندا-pr-وشنغن",
      "zh-Hans": "签证照片上传失败-年-ds-160-ukvi-印度-evisa-加拿大-pr-和申根文件排查",
      "de": "visafoto-upload-fehlgeschlagen-fehlerbehebung-fur-ds-160-ukvi-indien-visa-photo",
      "pt": "falha-no-upload-da-foto-de-visto-solucoes-para-ds-160-ukvi-evisa-indi-visa-photo"
    }
  },
  {
    "slug": "compress-visa-photo-to-kb-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "compress-visa-photo-to-kb-guide",
      "es": "comprimir-una-foto-de-visa-a-limites-en-kb-240-kb-1-mb-4-mb-calida-compress-visa",
      "fr": "compresser-une-photo-de-visa-aux-limites-en-kb-240-kb-1-mb-4-mb-qu-compress-visa",
      "ar": "ضغط-صورة-التا-شيرة-ا-لى-حدود-kb-240-kb-و1-mb-و4-mb-وجودة-jpeg-وا-ع-compress-visa",
      "zh-Hans": "将签证照片压缩到-kb-限制-240-kb-1-mb-4-mb-jpeg-质量和安全重新导出",
      "de": "visafoto-auf-kb-grenzen-komprimieren-240-kb-1-mb-4-mb-jpeg-qualita-compress-visa",
      "pt": "comprimir-foto-de-visto-para-limites-em-kb-240-kb-1-mb-4-mb-qualid-compress-visa"
    }
  },
  {
    "slug": "heic-to-jpeg-passport-visa-photo-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "heic-to-jpeg-passport-visa-photo-guide",
      "es": "heic-a-jpeg-para-fotos-de-pasaporte-y-visa-corrige-subidas-de-iphone-sin-heic-to",
      "fr": "heic-vers-jpeg-pour-photos-de-passeport-et-visa-corriger-les-envois-ipho-heic-to",
      "ar": "تحويل-heic-ا-لى-jpeg-لصور-جواز-السفر-والتا-شيرة-حل-مشاكل-رفع-iphone-دون-heic-to",
      "zh-Hans": "护照和签证照片-heic-转-jpeg-解决-iphone-上传问题且不破坏裁剪",
      "de": "heic-zu-jpeg-fur-pass-und-visafotos-iphone-uploadprobleme-beheben-ohne-d-heic-to",
      "pt": "heic-para-jpeg-em-fotos-de-passaporte-e-visto-corrija-uploads-do-iphone-heic-to"
    }
  },
  {
    "slug": "visa-photo-validator-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "visa-photo-validator-guide",
      "es": "validador-de-fotos-para-visa-como-revisar-una-foto-antes-de-enviarla",
      "fr": "validateur-de-photo-de-visa-comment-verifier-une-photo-avant-lenvoi",
      "ar": "مدقق-صور-التا-شيرة-كيف-تراجع-صورة-التا-شيرة-قبل-الا-رسال",
      "zh-Hans": "签证照片验证器-提交前如何检查签证照片",
      "de": "visafoto-validator-so-prufst-du-ein-visafoto-vor-dem-einreichen",
      "pt": "validador-de-foto-para-visto-como-revisar-uma-foto-antes-do-envio"
    }
  },
  {
    "slug": "passport-photo-upload-checker-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-upload-checker-guide",
      "es": "comprobador-de-subida-para-fotos-de-pasaporte-controles-de-cumpli-passport-photo",
      "fr": "verificateur-de-televersement-de-photo-de-passeport-controles-num-passport-photo",
      "ar": "مدقق-رفع-صور-جواز-السفر-فحوصات-الامتثال-الرقمي-قبل-الا-رسال",
      "zh-Hans": "护照照片上传检查器-提交前的数字合规检查",
      "de": "passfoto-upload-prufer-digitale-compliance-prufung-vor-dem-einreichen",
      "pt": "verificador-de-envio-da-foto-de-passaporte-checagens-digitais-antes-do-envio"
    }
  },
  {
    "slug": "passport-photo-file-size-checker-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-file-size-checker-guide",
      "es": "comprobador-de-tamano-de-archivo-para-fotos-de-pasaporte-corrige-passport-photo",
      "fr": "verificateur-de-taille-de-fichier-pour-photo-de-passeport-corrige-passport-photo",
      "ar": "مدقق-حجم-ملف-صورة-جواز-السفر-ا-صلاح-ملفات-الرفع-الكبيرة-ا-و-المرف-passport-photo",
      "zh-Hans": "护照照片文件大小检查器-在提交前修复过大或被拒的上传文件",
      "de": "passfoto-dateigroßen-prufer-zu-große-oder-abgelehnte-uploads-vor-passport-photo",
      "pt": "verificador-de-tamanho-do-arquivo-da-foto-de-passaporte-corrija-u-passport-photo"
    }
  },
  {
    "slug": "collage-photo-maker-print-layout",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "collage-photo-maker-print-layout",
      "es": "creador-de-collages-para-hojas-de-impresion-de-pasaporte-e-identificacion",
      "fr": "createur-de-collage-pour-feuilles-dimpression-de-photos-de-passepo-collage-photo",
      "ar": "صانع-تخطيطات-وتجميع-صور-لطباعة-جواز-السفر-والهوية",
      "zh-Hans": "护照与证件照打印排版拼贴工具指南",
      "de": "collage-fotomacher-fur-pass-und-id-drucklayouts",
      "pt": "criador-de-colagem-para-layouts-de-impressao-de-passaporte-e-identificacao"
    }
  },
  {
    "slug": "passport-photo-background-rules",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-background-rules",
      "es": "reglas-de-fondo-para-fotos-de-pasaporte-blanco-gris-azul-y-requisitos-por-pais",
      "fr": "regles-de-fond-pour-photo-de-passeport-blanc-gris-bleu-et-exigences-par-pays",
      "ar": "قواعد-خلفية-صور-جواز-السفر-ا-بيض-ورمادي-وا-زرق-ومتطلبات-حسب-الدولة",
      "zh-Hans": "护照照片背景规则-白色-灰色-蓝色与各国要求",
      "de": "hintergrundregeln-furs-passfoto-weiß-grau-blau-und-landerspezifische-vorgaben",
      "pt": "regras-de-fundo-para-foto-de-passaporte-branco-cinza-azul-e-exigencias-por-pais"
    }
  },
  {
    "slug": "diy-passport-photos-at-home",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "diy-passport-photos-at-home",
      "es": "fotos-de-pasaporte-diy-en-casa-guia-paso-a-paso-con-passlens",
      "fr": "photo-de-passeport-diy-a-la-maison-guide-etape-par-etape-avec-passlens",
      "ar": "صور-جواز-سفر-diy-في-المنزل-دليل-خطوة-بخطوة-باستخدام-passlens",
      "zh-Hans": "在家-diy-护照照-使用-passlens-的步骤指南",
      "de": "diy-passfotos-zu-hause-schritt-fur-schritt-mit-passlens",
      "pt": "fotos-de-passaporte-diy-em-casa-guia-passo-a-passo-usando-passlens"
    }
  },
  {
    "slug": "digital-vs-printed-passport-photos",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "digital-vs-printed-passport-photos",
      "es": "fotos-de-pasaporte-digitales-vs-impresas-cuando-necesitas-cada-una-y-digital-vs",
      "fr": "photos-de-passeport-numeriques-vs-imprimees-quand-utiliser-chaque-format",
      "ar": "صور-جواز-السفر-الرقمية-مقابل-المطبوعة-متى-تحتاج-كل-واحدة",
      "zh-Hans": "电子护照照-vs-打印护照照-何时需要哪种",
      "de": "digitale-vs-gedruckte-passfotos-wann-du-was-brauchst",
      "pt": "fotos-de-passaporte-digitais-vs-impressas-quando-voce-precisa-de-cada-uma"
    }
  },
  {
    "slug": "common-passport-photo-mistakes",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "common-passport-photo-mistakes",
      "es": "10-errores-comunes-en-fotos-de-pasaporte-que-causan-rechazos-y-como-evitarlos",
      "fr": "10-erreurs-courantes-de-photo-de-passeport-qui-entrainent-des-re-common-passport",
      "ar": "10-ا-خطاء-شاي-عة-في-صور-جواز-السفر-تسبب-الرفض-وكيف-تتجنبها",
      "zh-Hans": "10-个常见护照照错误-导致拒收-及避免方法",
      "de": "10-haufige-passfoto-fehler-die-zu-ablehnungen-fuhren-und-wie-du-sie-vermeidest",
      "pt": "10-erros-comuns-em-fotos-de-passaporte-que-causam-reprovacao-e-como-evitar"
    }
  },
  {
    "slug": "baby-passport-photo-tips",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "baby-passport-photo-tips",
      "es": "consejos-para-fotos-de-pasaporte-de-bebes-como-fotografiar-infante-baby-passport",
      "fr": "conseils-photo-de-passeport-bebe-photographier-nourrissons-et-tout-petits",
      "ar": "نصاي-ح-صور-جواز-السفر-للرض-ع-كيفية-تصوير-الا-طفال-للوثاي-ق",
      "zh-Hans": "宝宝护照照技巧-如何拍摄婴儿与幼儿证件照",
      "de": "baby-passfoto-tipps-so-fotografierst-du-sauglinge-und-kleinkinder",
      "pt": "dicas-para-foto-de-passaporte-de-bebe-como-fotografar-bebes-e-criancas-pequenas"
    }
  },
  {
    "slug": "baby-passport-photo-online-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "baby-passport-photo-online-guide",
      "es": "foto-de-pasaporte-para-bebe-online-preparacion-recorte-y-fondo",
      "fr": "photo-de-passeport-bebe-en-ligne-prise-de-vue-recadrage-et-fond",
      "ar": "صورة-جواز-سفر-للرضيع-عبر-الا-نترنت-الا-عداد-والقص-وفحص-الخلفية",
      "zh-Hans": "在线婴儿护照照片-拍摄-裁剪与背景检查",
      "de": "baby-passfoto-online-aufnahme-zuschnitt-und-hintergrund-prufen",
      "pt": "foto-de-passaporte-para-bebe-online-preparacao-corte-e-fundo"
    }
  },
  {
    "slug": "passport-photo-for-online-applications",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photo-for-online-applications",
      "es": "requisitos-de-foto-digital-para-solicitudes-online-tamanos-limite-passport-photo",
      "fr": "exigences-de-photo-de-passeport-numerique-pour-les-demarches-en-l-passport-photo",
      "ar": "متطلبات-صورة-الجواز-الرقمية-للطلبات-الا-لكترونية-المقاسات-وحدود-ا-passport-photo",
      "zh-Hans": "在线申请的数字护照照片要求-尺寸-文件限制和上传技巧",
      "de": "digitale-passfoto-anforderungen-fur-online-antrage-großen-dateili-passport-photo",
      "pt": "requisitos-de-foto-digital-para-solicitacoes-online-tamanhos-limi-passport-photo"
    }
  },
  {
    "slug": "passport-photos-near-me",
    "updatedAt": "2026-05-24",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photos-near-me",
      "es": "donde-puedo-hacerme-una-foto-de-pasaporte-estudios-farmacias-imp-passport-photos",
      "fr": "ou-faire-une-photo-de-passeport-pres-de-chez-moi-studios-pharmac-passport-photos",
      "ar": "ا-ين-يمكنني-الحصول-على-صورة-جواز-سفر-استوديوهات-وصيدليات-وطباعة-وخيارات-قريبة",
      "zh-Hans": "哪里可以拍护照照片-附近的照相馆-药房-打印点和居家方案",
      "de": "wo-kann-ich-passfotos-machen-lassen-studios-apotheken-druckservi-passport-photos",
      "pt": "onde-posso-tirar-foto-para-passaporte-estudios-farmacias-impress-passport-photos"
    }
  },
  {
    "slug": "passport-photos-california-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photos-california-guide",
      "es": "fotos-de-pasaporte-en-california-los-angeles-san-francisco-san-d-passport-photos",
      "fr": "photos-de-passeport-en-californie-los-angeles-san-francisco-san-passport-photos",
      "ar": "صور-جواز-السفر-في-كاليفورنيا-لوس-ا-نجلوس-وسان-فرانسيسكو-وسان-ديي-passport-photos",
      "zh-Hans": "加州护照照片-洛杉矶-旧金山-圣迭戈-萨克拉门托和居家选项",
      "de": "passfotos-in-kalifornien-los-angeles-san-francisco-san-diego-sac-passport-photos",
      "pt": "fotos-de-passaporte-na-california-los-angeles-san-francisco-san-passport-photos"
    }
  },
  {
    "slug": "passport-photos-new-york-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photos-new-york-guide",
      "es": "fotos-de-pasaporte-en-nueva-york-nyc-brooklyn-queens-long-island-passport-photos",
      "fr": "photos-de-passeport-a-new-york-nyc-brooklyn-queens-long-island-n-passport-photos",
      "ar": "صور-جواز-السفر-في-نيويورك-nyc-وبروكلين-وكوينز-ولونغ-ا-يلاند-وشما-passport-photos",
      "zh-Hans": "纽约护照照片-nyc-布鲁克林-皇后区-长岛-上州和居家选项",
      "de": "passfotos-in-new-york-nyc-brooklyn-queens-long-island-upstate-un-passport-photos",
      "pt": "fotos-de-passaporte-em-nova-york-nyc-brooklyn-queens-long-island-passport-photos"
    }
  },
  {
    "slug": "passport-photos-las-vegas-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-photos-las-vegas-guide",
      "es": "fotos-de-pasaporte-en-las-vegas-usps-clark-county-tiendas-estudi-passport-photos",
      "fr": "photos-de-passeport-a-las-vegas-usps-clark-county-comptoirs-stud-passport-photos",
      "ar": "صور-جواز-السفر-في-لاس-فيغاس-usps-وكلارك-كاونتي-والمتاجر-والاستود-passport-photos",
      "zh-Hans": "拉斯维加斯护照照片-usps-克拉克县-零售柜台-影棚和居家选项",
      "de": "passfotos-in-las-vegas-usps-clark-county-handler-studios-und-optionen-zu-hause",
      "pt": "fotos-de-passaporte-em-las-vegas-usps-clark-county-balcoes-estud-passport-photos"
    }
  },
  {
    "slug": "cheapest-places-to-print-passport-photos",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "cheapest-places-to-print-passport-photos",
      "es": "lugares-mas-baratos-para-imprimir-fotos-de-pasaporte-casa-farmac-cheapest-places",
      "fr": "les-solutions-les-moins-cheres-pour-imprimer-des-photos-de-passe-cheapest-places",
      "ar": "ا-رخص-الا-ماكن-لطباعة-صور-جواز-السفر-المنزل-والصيدليات-ونقاط-الطباعة",
      "zh-Hans": "打印护照照片最省钱的方式-居家打印-药房和零售柜台",
      "de": "gunstige-orte-zum-drucken-von-passfotos-zuhause-apotheken-und-fototheken",
      "pt": "os-lugares-mais-baratos-para-imprimir-fotos-de-passaporte-casa-f-cheapest-places"
    }
  },
  {
    "slug": "usps-passport-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "usps-passport-photo-guide",
      "es": "fotos-de-pasaporte-en-usps-cuando-conviene-la-oficina-postal-que-r-usps-passport",
      "fr": "photo-de-passeport-usps-quand-le-bureau-de-poste-est-utile-ce-quil-usps-passport",
      "ar": "خدمة-صور-جواز-السفر-في-usps-متى-يفيدك-مكتب-البريد-وما-الذي-يقدمه-و-usps-passport",
      "zh-Hans": "usps-护照照片服务-邮局什么时候有用-它能解决什么-以及何时应先准备文件",
      "de": "usps-passfoto-service-wann-die-post-hilft-was-sie-abdeckt-und-wann-usps-passport",
      "pt": "foto-de-passaporte-no-usps-quando-os-correios-ajudam-o-que-resolve-usps-passport"
    }
  },
  {
    "slug": "passport-card-vs-book",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-card-vs-book",
      "es": "pasaporte-libreta-vs-tarjeta-que-documento-estadounidense-encaja-m-passport-card",
      "fr": "carte-passeport-ou-livret-quel-document-americain-convient-le-mieu-passport-card",
      "ar": "بطاقة-جواز-السفر-ا-م-الدفتر-ا-ي-وثيقة-ا-مريكية-تناسب-رحلتك-ا-كثر",
      "zh-Hans": "护照卡还是护照本-哪种美国旅行证件更适合你的行程",
      "de": "passkarte-oder-reisepass-welches-us-reisedokument-passt-besser-zu-deiner-reise",
      "pt": "passaporte-em-cartao-vs-livreto-qual-documento-dos-eua-faz-mais-se-passport-card"
    }
  },
  {
    "slug": "walgreens-vs-cvs-passport-photos",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "walgreens-vs-cvs-passport-photos",
      "es": "walgreens-vs-cvs-para-fotos-de-pasaporte-precio-comodidad-y-cuanto-walgreens-vs",
      "fr": "walgreens-ou-cvs-pour-les-photos-de-passeport-prix-praticite-et-niv-walgreens-vs",
      "ar": "walgreens-ا-م-cvs-لصور-جواز-السفر-السعر-والسهولة-ومقدار-التحكم-الحق-walgreens-vs",
      "zh-Hans": "walgreens-与-cvs-护照照片对比-价格-便利性-以及你真正能掌控多少",
      "de": "walgreens-oder-cvs-fur-passfotos-preis-komfort-und-wie-viel-kontrol-walgreens-vs",
      "pt": "walgreens-vs-cvs-para-fotos-de-passaporte-preco-praticidade-e-quant-walgreens-vs"
    }
  },
  {
    "slug": "passport-renewal-usps-fedex",
    "updatedAt": "2026-04-12",
    "indexable": true,
    "localizedSlugs": {
      "en": "passport-renewal-usps-fedex",
      "es": "renovar-el-pasaporte-usps-vs-fedex-office-que-hace-realmente-ca-passport-renewal",
      "fr": "renouvellement-de-passeport-usps-ou-fedex-office-ce-que-chacun-passport-renewal",
      "ar": "تجديد-جواز-السفر-usps-ا-م-fedex-office-ما-الذي-يفعله-كل-منهما-ف-passport-renewal",
      "zh-Hans": "护照续办-usps-与-fedex-office-各自真正负责什么-以及照片步骤应该放在哪里",
      "de": "passerneuerung-usps-oder-fedex-office-was-beide-wirklich-leiste-passport-renewal",
      "pt": "renovacao-de-passaporte-usps-vs-fedex-office-o-que-cada-um-real-passport-renewal"
    }
  },
  {
    "slug": "fedex-office-passport-photo-guide",
    "updatedAt": "2026-05-27",
    "indexable": true,
    "localizedSlugs": {
      "en": "fedex-office-passport-photo-guide",
      "es": "does-fedex-do-passport-photos-fedex-office-price-prints-digital-cop-fedex-office",
      "fr": "does-fedex-do-passport-photos-fedex-office-price-prints-digital-cop-fedex-office",
      "ar": "does-fedex-do-passport-photos-fedex-office-price-prints-digital-cop-fedex-office",
      "zh-Hans": "does-fedex-do-passport-photos-fedex-office-price-prints-digital-cop-fedex-office",
      "de": "does-fedex-do-passport-photos-fedex-office-price-prints-digital-cop-fedex-office",
      "pt": "does-fedex-do-passport-photos-fedex-office-price-prints-digital-cop-fedex-office"
    }
  },
  {
    "slug": "staples-passport-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "staples-passport-photo-guide",
      "es": "staples-passport-photos-same-day-prints-digital-copy-questions-staples-passport",
      "fr": "staples-passport-photos-same-day-prints-digital-copy-questions-staples-passport",
      "ar": "staples-passport-photos-same-day-prints-digital-copy-questions-staples-passport",
      "zh-Hans": "staples-passport-photos-same-day-prints-digital-copy-questions-staples-passport",
      "de": "staples-passport-photos-same-day-prints-digital-copy-questions-staples-passport",
      "pt": "staples-passport-photos-same-day-prints-digital-copy-questions-staples-passport"
    }
  },
  {
    "slug": "office-depot-passport-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "office-depot-passport-photo-guide",
      "es": "office-depot-passport-photo-printing-print-only-route-4x6-sheets-an-office-depot",
      "fr": "office-depot-passport-photo-printing-print-only-route-4x6-sheets-an-office-depot",
      "ar": "office-depot-passport-photo-printing-print-only-route-4x6-sheets-an-office-depot",
      "zh-Hans": "office-depot-passport-photo-printing-print-only-route-4x6-sheets-an-office-depot",
      "de": "office-depot-passport-photo-printing-print-only-route-4x6-sheets-an-office-depot",
      "pt": "office-depot-passport-photo-printing-print-only-route-4x6-sheets-an-office-depot"
    }
  },
  {
    "slug": "shoppers-drug-mart-passport-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "shoppers-drug-mart-passport-photo-guide",
      "es": "shoppers-drug-mart-passport-photos-canada-photo-size-store-availab-shoppers-drug",
      "fr": "shoppers-drug-mart-passport-photos-canada-photo-size-store-availab-shoppers-drug",
      "ar": "shoppers-drug-mart-passport-photos-canada-photo-size-store-availab-shoppers-drug",
      "zh-Hans": "shoppers-drug-mart-passport-photos-canada-photo-size-store-availab-shoppers-drug",
      "de": "shoppers-drug-mart-passport-photos-canada-photo-size-store-availab-shoppers-drug",
      "pt": "shoppers-drug-mart-passport-photos-canada-photo-size-store-availab-shoppers-drug"
    }
  },
  {
    "slug": "required-documents-for-us-passport",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "required-documents-for-us-passport",
      "es": "documentos-necesarios-para-el-pasaporte-de-ee-uu-identidad-ci-required-documents",
      "fr": "documents-requis-pour-un-passeport-americain-identite-citoyen-required-documents",
      "ar": "المستندات-المطلوبة-لجواز-السفر-الا-مريكي-الهوية-وا-ثبات-الجنسية-وصورة-الطلب",
      "zh-Hans": "申请美国护照所需文件-身份证明-公民身份材料和申请照片",
      "de": "benotigte-unterlagen-fur-einen-us-pass-identitat-staatsangeho-required-documents",
      "pt": "documentos-necessarios-para-o-passaporte-dos-eua-identidade-c-required-documents"
    }
  },
  {
    "slug": "us-passport-fees",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "us-passport-fees",
      "es": "tarifas-del-pasaporte-de-ee-uu-libreta-tarjeta-tramite-urgente-y-cos-us-passport",
      "fr": "frais-de-passeport-americain-livret-carte-service-accelere-et-couts-us-passport",
      "ar": "رسوم-جواز-السفر-الا-مريكي-الدفتر-والبطاقة-والخدمة-السريعة-والتكاليف-us-passport",
      "zh-Hans": "美国护照费用-护照本-护照卡-加急服务-以及人们常漏算的成本",
      "de": "us-passgebuhren-reisepass-passkarte-expressservice-und-kosten-die-of-us-passport",
      "pt": "taxas-do-passaporte-dos-eua-livreto-cartao-urgencia-e-custos-que-mui-us-passport"
    }
  },
  {
    "slug": "track-us-passport-status",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "track-us-passport-status",
      "es": "como-seguir-el-estado-del-pasaporte-de-ee-uu-que-significan-los-estados-track-us",
      "fr": "suivre-le-statut-dun-passeport-americain-comprendre-les-etats-et-savoir-track-us",
      "ar": "كيفية-تتبع-حالة-جواز-السفر-الا-مريكي-ماذا-تعني-الحالات-ومتى-يجب-المتابعة",
      "zh-Hans": "如何查询美国护照状态-各状态代表什么-以及何时跟进",
      "de": "us-passstatus-verfolgen-was-die-statusmeldungen-bedeuten-und-wann-du-na-track-us",
      "pt": "como-acompanhar-o-status-do-passaporte-dos-eua-o-que-cada-etapa-signifi-track-us"
    }
  },
  {
    "slug": "us-passport-photo-guide",
    "updatedAt": "2026-05-27",
    "indexable": true,
    "localizedSlugs": {
      "en": "us-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-estados-unidos",
      "fr": "exigences-de-photo-pour-passeport-de-etats-unis",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-الولايات-المتحدة",
      "zh-Hans": "美国-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-vereinigte-staaten",
      "pt": "requisitos-de-foto-para-passaporte-de-estados-unidos"
    }
  },
  {
    "slug": "uk-passport-photo-guide",
    "updatedAt": "2026-04-13",
    "indexable": true,
    "localizedSlugs": {
      "en": "uk-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-reino-unido",
      "fr": "exigences-de-photo-pour-passeport-de-royaume-uni",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-المملكة-المتحدة",
      "zh-Hans": "英国-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-vereinigtes-konigreich",
      "pt": "requisitos-de-foto-para-passaporte-de-reino-unido"
    }
  },
  {
    "slug": "canada-passport-photo-guide",
    "updatedAt": "2026-05-16",
    "indexable": true,
    "localizedSlugs": {
      "en": "canada-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-canada",
      "fr": "exigences-de-photo-pour-passeport-de-canada",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-كندا",
      "zh-Hans": "加拿大-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-kanada",
      "pt": "requisitos-de-foto-para-passaporte-de-canada"
    }
  },
  {
    "slug": "belgium-passport-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "belgium-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-belgica",
      "fr": "exigences-de-photo-pour-passeport-de-belgique",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-بلجيكا",
      "zh-Hans": "比利时-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-belgien",
      "pt": "requisitos-de-foto-para-passaporte-de-belgica"
    }
  },
  {
    "slug": "germany-passport-photo-guide",
    "updatedAt": "2026-05-27",
    "indexable": true,
    "localizedSlugs": {
      "en": "germany-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-alemania",
      "fr": "exigences-de-photo-pour-passeport-de-allemagne",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-ا-لمانيا",
      "zh-Hans": "德国-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-deutschland",
      "pt": "requisitos-de-foto-para-passaporte-de-alemanha"
    }
  },
  {
    "slug": "france-passport-photo-guide",
    "updatedAt": "2026-05-27",
    "indexable": true,
    "localizedSlugs": {
      "en": "france-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-francia",
      "fr": "exigences-de-photo-pour-passeport-de-france",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-فرنسا",
      "zh-Hans": "法国-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-frankreich",
      "pt": "requisitos-de-foto-para-passaporte-de-franca"
    }
  },
  {
    "slug": "netherlands-passport-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "netherlands-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-paises-bajos",
      "fr": "exigences-de-photo-pour-passeport-de-pays-bas",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-هولندا",
      "zh-Hans": "荷兰-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-niederlande",
      "pt": "requisitos-de-foto-para-passaporte-de-paises-baixos"
    }
  },
  {
    "slug": "spain-passport-photo-guide",
    "updatedAt": "2026-05-16",
    "indexable": true,
    "localizedSlugs": {
      "en": "spain-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-espana",
      "fr": "exigences-de-photo-pour-passeport-de-espagne",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-ا-سبانيا",
      "zh-Hans": "西班牙-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-spanien",
      "pt": "requisitos-de-foto-para-passaporte-de-espanha"
    }
  },
  {
    "slug": "italy-passport-photo-guide",
    "updatedAt": "2026-07-06",
    "indexable": true,
    "localizedSlugs": {
      "en": "italy-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-italia",
      "fr": "exigences-photo-pour-passeport-italien",
      "ar": "متطلبات-صورة-جواز-السفر-الا-يطالي",
      "zh-Hans": "意大利护照照片要求",
      "de": "anforderungen-an-italienische-passfotos",
      "pt": "requisitos-de-foto-para-passaporte-italiano"
    }
  },
  {
    "slug": "brazil-passport-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "brazil-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-brasil",
      "fr": "exigences-de-photo-pour-passeport-de-bresil",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-البرازيل",
      "zh-Hans": "巴西-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-brasilien",
      "pt": "requisitos-de-foto-para-passaporte-de-brasil"
    }
  },
  {
    "slug": "greece-passport-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "greece-passport-photo-guide",
      "es": "greece-passport-photo-requirements-myphoto-digital-submission-40-greece-passport",
      "fr": "greece-passport-photo-requirements-myphoto-digital-submission-40-greece-passport",
      "ar": "greece-passport-photo-requirements-myphoto-digital-submission-40-greece-passport",
      "zh-Hans": "greece-passport-photo-requirements-myphoto-digital-submission-40-greece-passport",
      "de": "greece-passport-photo-requirements-myphoto-digital-submission-40-greece-passport",
      "pt": "greece-passport-photo-requirements-myphoto-digital-submission-40-greece-passport"
    }
  },
  {
    "slug": "haiti-passport-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "haiti-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-haitiano-reglas-de-la-embajada-haiti-passport",
      "fr": "exigences-photo-pour-passeport-haitien-regles-de-lambassade-dhait-haiti-passport",
      "ar": "متطلبات-صورة-جواز-السفر-الهايتي-قواعد-سفارة-هايتي-مدة-الصلاحية-وملاحظات-الفقدان",
      "zh-Hans": "海地护照照片要求-海地驻华盛顿使馆规则-有效期与遗失说明",
      "de": "haitianische-passfoto-anforderungen-regeln-der-botschaft-haitis-g-haiti-passport",
      "pt": "requisitos-de-foto-para-passaporte-haitiano-regras-da-embaixada-d-haiti-passport"
    }
  },
  {
    "slug": "jamaica-passport-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "jamaica-passport-photo-guide",
      "es": "jamaica-passport-photo-requirements-pica-35x45-mm-size-25-35-mm-jamaica-passport",
      "fr": "jamaica-passport-photo-requirements-pica-35x45-mm-size-25-35-mm-jamaica-passport",
      "ar": "jamaica-passport-photo-requirements-pica-35x45-mm-size-25-35-mm-jamaica-passport",
      "zh-Hans": "jamaica-passport-photo-requirements-pica-35x45-mm-size-25-35-mm-jamaica-passport",
      "de": "jamaica-passport-photo-requirements-pica-35x45-mm-size-25-35-mm-jamaica-passport",
      "pt": "jamaica-passport-photo-requirements-pica-35x45-mm-size-25-35-mm-jamaica-passport"
    }
  },
  {
    "slug": "bangladesh-passport-photo-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "bangladesh-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-banglades-tamano-55x45-bangladesh-passport",
      "fr": "exigences-photo-pour-passeport-bangladais-format-55x45-mm-et-bangladesh-passport",
      "ar": "متطلبات-صورة-جواز-سفر-بنغلادش-مقاس-55x45-مم-وملاحظات-نموذج-الطلب",
      "zh-Hans": "孟加拉国护照照片要求-55x45-毫米尺寸与申请表注意事项",
      "de": "bangladesch-passfoto-anforderungen-55x45-mm-format-und-formularhinweise",
      "pt": "requisitos-de-foto-para-passaporte-de-bangladesh-tamanho-55x-bangladesh-passport"
    }
  },
  {
    "slug": "malaysia-passport-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "malaysia-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-malasia",
      "fr": "exigences-de-photo-pour-passeport-de-malaisie",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-ماليزيا",
      "zh-Hans": "马来西亚-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-malaysia",
      "pt": "requisitos-de-foto-para-passaporte-de-malasia"
    }
  },
  {
    "slug": "india-passport-photo-guide",
    "updatedAt": "2026-07-06",
    "indexable": true,
    "localizedSlugs": {
      "en": "india-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-india",
      "fr": "exigences-de-photo-pour-passeport-de-inde",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-الهند",
      "zh-Hans": "印度-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-indien",
      "pt": "requisitos-de-foto-para-passaporte-de-india"
    }
  },
  {
    "slug": "australia-passport-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "australia-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-australia",
      "fr": "exigences-de-photo-pour-passeport-de-australie",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-ا-ستراليا",
      "zh-Hans": "澳大利亚-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-australien",
      "pt": "requisitos-de-foto-para-passaporte-de-australia"
    }
  },
  {
    "slug": "japan-passport-photo-guide",
    "updatedAt": "2026-05-27",
    "indexable": true,
    "localizedSlugs": {
      "en": "japan-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-japon",
      "fr": "exigences-de-photo-pour-passeport-de-japon",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-اليابان",
      "zh-Hans": "日本-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-japan",
      "pt": "requisitos-de-foto-para-passaporte-de-japao"
    }
  },
  {
    "slug": "south-korea-passport-photo-guide",
    "updatedAt": "2026-05-25",
    "indexable": true,
    "localizedSlugs": {
      "en": "south-korea-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-corea-del-sur",
      "fr": "exigences-de-photo-pour-passeport-de-coree-du-sud",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-كوريا-الجنوبية",
      "zh-Hans": "韩国-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-sudkorea",
      "pt": "requisitos-de-foto-para-passaporte-de-coreia-do-sul"
    }
  },
  {
    "slug": "singapore-passport-photo-guide",
    "updatedAt": "2026-07-06",
    "indexable": true,
    "localizedSlugs": {
      "en": "singapore-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-singapur",
      "fr": "exigences-de-photo-pour-passeport-de-singapour",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-سنغافورة",
      "zh-Hans": "新加坡-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-singapur",
      "pt": "requisitos-de-foto-para-passaporte-de-singapura"
    }
  },
  {
    "slug": "hong-kong-passport-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "hong-kong-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-rae-de-hong-kong-china",
      "fr": "exigences-de-photo-pour-passeport-de-r-a-s-chinoise-de-hong-kong",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-هونغ-كونغ-الصينية-منطقة-ا-دارية-خاصة",
      "zh-Hans": "中国香港特别行政区-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-sonderverwaltungsregion-hongkong",
      "pt": "requisitos-de-foto-para-passaporte-de-hong-kong-rae-da-china"
    }
  },
  {
    "slug": "taiwan-passport-photo-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "taiwan-passport-photo-guide",
      "es": "taiwan-passport-photo-requirements-boca-35x45-mm-size-32-36-mm-h-taiwan-passport",
      "fr": "taiwan-passport-photo-requirements-boca-35x45-mm-size-32-36-mm-h-taiwan-passport",
      "ar": "taiwan-passport-photo-requirements-boca-35x45-mm-size-32-36-mm-h-taiwan-passport",
      "zh-Hans": "taiwan-passport-photo-requirements-boca-35x45-mm-size-32-36-mm-h-taiwan-passport",
      "de": "taiwan-passport-photo-requirements-boca-35x45-mm-size-32-36-mm-h-taiwan-passport",
      "pt": "taiwan-passport-photo-requirements-boca-35x45-mm-size-32-36-mm-h-taiwan-passport"
    }
  },
  {
    "slug": "ireland-passport-photo-guide",
    "updatedAt": "2026-05-16",
    "indexable": true,
    "localizedSlugs": {
      "en": "ireland-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-irlanda",
      "fr": "exigences-de-photo-pour-passeport-de-irlande",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-ا-يرلندا",
      "zh-Hans": "爱尔兰-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-irland",
      "pt": "requisitos-de-foto-para-passaporte-de-irlanda"
    }
  },
  {
    "slug": "new-zealand-passport-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "new-zealand-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-nueva-zelanda",
      "fr": "exigences-photo-pour-passeport-neo-zelandais",
      "ar": "متطلبات-صورة-جواز-سفر-نيوزيلندا",
      "zh-Hans": "新西兰护照照片要求",
      "de": "anforderungen-an-neuseelandische-passfotos",
      "pt": "requisitos-de-foto-para-passaporte-da-nova-zelandia"
    }
  },
  {
    "slug": "turkey-passport-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "turkey-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-turquia",
      "fr": "exigences-de-photo-pour-passeport-de-turquie",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-تركيا",
      "zh-Hans": "土耳其-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-turkei",
      "pt": "requisitos-de-foto-para-passaporte-de-turquia"
    }
  },
  {
    "slug": "mexico-passport-photo-guide",
    "updatedAt": "2026-05-27",
    "indexable": true,
    "localizedSlugs": {
      "en": "mexico-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-mexico",
      "fr": "exigences-de-photo-pour-passeport-de-mexique",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-المكسيك",
      "zh-Hans": "墨西哥-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-mexiko",
      "pt": "requisitos-de-foto-para-passaporte-de-mexico"
    }
  },
  {
    "slug": "philippines-passport-photo-guide",
    "updatedAt": "2026-07-03",
    "indexable": true,
    "localizedSlugs": {
      "en": "philippines-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-filipinas",
      "fr": "exigences-de-photo-pour-passeport-de-philippines",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-الفلبين",
      "zh-Hans": "菲律宾-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-philippinen",
      "pt": "requisitos-de-foto-para-passaporte-de-filipinas"
    }
  },
  {
    "slug": "south-africa-passport-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "south-africa-passport-photo-guide",
      "es": "requisitos-de-foto-para-pasaporte-de-sudafrica",
      "fr": "exigences-de-photo-pour-passeport-de-afrique-du-sud",
      "ar": "متطلبات-صورة-جواز-سفر-لـ-جنوب-ا-فريقيا",
      "zh-Hans": "南非-护照-照片要求",
      "de": "fotoanforderungen-fur-reisepass-in-sudafrika",
      "pt": "requisitos-de-foto-para-passaporte-de-africa-do-sul"
    }
  },
  {
    "slug": "us-visa-photo-guide",
    "updatedAt": "2026-05-20",
    "indexable": true,
    "localizedSlugs": {
      "en": "us-visa-photo-guide",
      "es": "requisitos-de-foto-para-visa-de-estados-unidos",
      "fr": "exigences-de-photo-pour-visa-de-etats-unis",
      "ar": "متطلبات-صورة-تا-شيرة-لـ-الولايات-المتحدة",
      "zh-Hans": "美国-签证-照片要求",
      "de": "fotoanforderungen-fur-visum-in-vereinigte-staaten",
      "pt": "requisitos-de-foto-para-visto-de-estados-unidos"
    }
  },
  {
    "slug": "germany-id-card-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "germany-id-card-photo-guide",
      "es": "requisitos-de-foto-para-documento-nacional-de-identidad-de-alemania",
      "fr": "exigences-de-photo-pour-carte-didentite-de-allemagne",
      "ar": "متطلبات-صورة-هوية-وطنية-لـ-ا-لمانيا",
      "zh-Hans": "德国-身份证-照片要求",
      "de": "fotoanforderungen-fur-personalausweis-in-deutschland",
      "pt": "requisitos-de-foto-para-documento-de-identidade-de-alemanha"
    }
  },
  {
    "slug": "germany-driving-licence-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "germany-driving-licence-photo-guide",
      "es": "requisitos-de-foto-para-permiso-de-conducir-de-alemania",
      "fr": "exigences-de-photo-pour-permis-de-conduire-de-allemagne",
      "ar": "متطلبات-صورة-رخصة-قيادة-لـ-ا-لمانيا",
      "zh-Hans": "德国-驾驶证-照片要求",
      "de": "fotoanforderungen-fur-fuhrerschein-in-deutschland",
      "pt": "requisitos-de-foto-para-carta-de-conducao-de-alemanha"
    }
  },
  {
    "slug": "france-id-card-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "france-id-card-photo-guide",
      "es": "requisitos-de-foto-para-documento-nacional-de-identidad-de-francia",
      "fr": "exigences-de-photo-pour-carte-didentite-de-france",
      "ar": "متطلبات-صورة-هوية-وطنية-لـ-فرنسا",
      "zh-Hans": "法国-身份证-照片要求",
      "de": "fotoanforderungen-fur-personalausweis-in-frankreich",
      "pt": "requisitos-de-foto-para-documento-de-identidade-de-franca"
    }
  },
  {
    "slug": "france-driving-licence-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "france-driving-licence-photo-guide",
      "es": "requisitos-de-foto-para-permiso-de-conducir-de-francia",
      "fr": "exigences-de-photo-pour-permis-de-conduire-de-france",
      "ar": "متطلبات-صورة-رخصة-قيادة-لـ-فرنسا",
      "zh-Hans": "法国-驾驶证-照片要求",
      "de": "fotoanforderungen-fur-fuhrerschein-in-frankreich",
      "pt": "requisitos-de-foto-para-carta-de-conducao-de-franca"
    }
  },
  {
    "slug": "belgium-id-card-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "belgium-id-card-photo-guide",
      "es": "requisitos-de-foto-para-documento-nacional-de-identidad-de-belgica",
      "fr": "exigences-de-photo-pour-carte-didentite-de-belgique",
      "ar": "متطلبات-صورة-هوية-وطنية-لـ-بلجيكا",
      "zh-Hans": "比利时-身份证-照片要求",
      "de": "fotoanforderungen-fur-personalausweis-in-belgien",
      "pt": "requisitos-de-foto-para-documento-de-identidade-de-belgica"
    }
  },
  {
    "slug": "uk-driving-licence-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "uk-driving-licence-photo-guide",
      "es": "requisitos-de-foto-para-permiso-de-conducir-de-reino-unido",
      "fr": "exigences-de-photo-pour-permis-de-conduire-de-royaume-uni",
      "ar": "متطلبات-صورة-رخصة-قيادة-لـ-المملكة-المتحدة",
      "zh-Hans": "英国-驾驶证-照片要求",
      "de": "fotoanforderungen-fur-fuhrerschein-in-vereinigtes-konigreich",
      "pt": "requisitos-de-foto-para-carta-de-conducao-de-reino-unido"
    }
  },
  {
    "slug": "south-africa-id-card-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "south-africa-id-card-photo-guide",
      "es": "requisitos-de-foto-para-documento-nacional-de-identidad-de-sudafrica",
      "fr": "exigences-de-photo-pour-carte-didentite-de-afrique-du-sud",
      "ar": "متطلبات-صورة-هوية-وطنية-لـ-جنوب-ا-فريقيا",
      "zh-Hans": "南非-身份证-照片要求",
      "de": "fotoanforderungen-fur-personalausweis-in-sudafrika",
      "pt": "requisitos-de-foto-para-documento-de-identidade-de-africa-do-sul"
    }
  },
  {
    "slug": "netherlands-id-card-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "netherlands-id-card-photo-guide",
      "es": "requisitos-de-foto-para-documento-nacional-de-identidad-de-paises-bajos",
      "fr": "exigences-de-photo-pour-carte-didentite-de-pays-bas",
      "ar": "متطلبات-صورة-هوية-وطنية-لـ-هولندا",
      "zh-Hans": "荷兰-身份证-照片要求",
      "de": "fotoanforderungen-fur-personalausweis-in-niederlande",
      "pt": "requisitos-de-foto-para-documento-de-identidade-de-paises-baixos"
    }
  },
  {
    "slug": "netherlands-driving-licence-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "netherlands-driving-licence-photo-guide",
      "es": "requisitos-de-foto-para-permiso-de-conducir-de-paises-bajos",
      "fr": "exigences-de-photo-pour-permis-de-conduire-de-pays-bas",
      "ar": "متطلبات-صورة-رخصة-قيادة-لـ-هولندا",
      "zh-Hans": "荷兰-驾驶证-照片要求",
      "de": "fotoanforderungen-fur-fuhrerschein-in-niederlande",
      "pt": "requisitos-de-foto-para-carta-de-conducao-de-paises-baixos"
    }
  },
  {
    "slug": "spain-dni-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "spain-dni-photo-guide",
      "es": "requisitos-de-foto-para-documento-nacional-de-identidad-de-espana",
      "fr": "exigences-de-photo-pour-carte-didentite-de-espagne",
      "ar": "متطلبات-صورة-هوية-وطنية-لـ-ا-سبانيا",
      "zh-Hans": "西班牙-身份证-照片要求",
      "de": "fotoanforderungen-fur-personalausweis-in-spanien",
      "pt": "requisitos-de-foto-para-documento-de-identidade-de-espanha"
    }
  },
  {
    "slug": "spain-driving-licence-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "spain-driving-licence-photo-guide",
      "es": "requisitos-de-foto-para-permiso-de-conducir-de-espana",
      "fr": "exigences-de-photo-pour-permis-de-conduire-de-espagne",
      "ar": "متطلبات-صورة-رخصة-قيادة-لـ-ا-سبانيا",
      "zh-Hans": "西班牙-驾驶证-照片要求",
      "de": "fotoanforderungen-fur-fuhrerschein-in-spanien",
      "pt": "requisitos-de-foto-para-carta-de-conducao-de-espanha"
    }
  },
  {
    "slug": "italy-id-card-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "italy-id-card-photo-guide",
      "es": "requisitos-de-foto-para-documento-nacional-de-identidad-de-italia",
      "fr": "exigences-de-photo-pour-carte-didentite-de-italie",
      "ar": "متطلبات-صورة-هوية-وطنية-لـ-ا-يطاليا",
      "zh-Hans": "意大利-身份证-照片要求",
      "de": "fotoanforderungen-fur-personalausweis-in-italien",
      "pt": "requisitos-de-foto-para-documento-de-identidade-de-italia"
    }
  },
  {
    "slug": "italy-driving-licence-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "italy-driving-licence-photo-guide",
      "es": "requisitos-de-foto-para-permiso-de-conducir-de-italia",
      "fr": "exigences-de-photo-pour-permis-de-conduire-de-italie",
      "ar": "متطلبات-صورة-رخصة-قيادة-لـ-ا-يطاليا",
      "zh-Hans": "意大利-驾驶证-照片要求",
      "de": "fotoanforderungen-fur-fuhrerschein-in-italien",
      "pt": "requisitos-de-foto-para-carta-de-conducao-de-italia"
    }
  },
  {
    "slug": "singapore-id-card-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "singapore-id-card-photo-guide",
      "es": "requisitos-de-foto-para-documento-nacional-de-identidad-de-singapur",
      "fr": "exigences-de-photo-pour-carte-didentite-de-singapour",
      "ar": "متطلبات-صورة-هوية-وطنية-لـ-سنغافورة",
      "zh-Hans": "新加坡-身份证-照片要求",
      "de": "fotoanforderungen-fur-personalausweis-in-singapur",
      "pt": "requisitos-de-foto-para-documento-de-identidade-de-singapura"
    }
  },
  {
    "slug": "japan-visa-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "japan-visa-photo-guide",
      "es": "requisitos-de-foto-para-visa-de-japon-tamano-45x35-mm-regla-de-6-mese-japan-visa",
      "fr": "exigences-photo-pour-visa-japonais-format-45x35-mm-regle-des-6-mois-e-japan-visa",
      "ar": "متطلبات-صورة-تا-شيرة-اليابان-مقاس-45x35-مم-قاعدة-الستة-ا-شهر-وملاحظات-القنصلية",
      "zh-Hans": "日本签证照片要求-45x35-毫米尺寸-6-个月规则与使领馆说明",
      "de": "japan-visafoto-anforderungen-45x35-mm-6-monats-regel-und-botschaftshinweise",
      "pt": "requisitos-de-foto-para-visto-do-japao-tamanho-45x35-mm-regra-dos-6-m-japan-visa"
    }
  },
  {
    "slug": "vietnam-evisa-photo-requirements-guide",
    "updatedAt": "2026-05-15",
    "indexable": true,
    "localizedSlugs": {
      "en": "vietnam-evisa-photo-requirements-guide",
      "es": "vietnam-evisa-photo-requirements-4x6-cm-portrait-jpg-jpeg-upload-w-vietnam-evisa",
      "fr": "vietnam-evisa-photo-requirements-4x6-cm-portrait-jpg-jpeg-upload-w-vietnam-evisa",
      "ar": "vietnam-evisa-photo-requirements-4x6-cm-portrait-jpg-jpeg-upload-w-vietnam-evisa",
      "zh-Hans": "vietnam-evisa-photo-requirements-4x6-cm-portrait-jpg-jpeg-upload-w-vietnam-evisa",
      "de": "vietnam-evisa-photo-requirements-4x6-cm-portrait-jpg-jpeg-upload-w-vietnam-evisa",
      "pt": "vietnam-evisa-photo-requirements-4x6-cm-portrait-jpg-jpeg-upload-w-vietnam-evisa"
    }
  },
  {
    "slug": "singapore-visa-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "singapore-visa-photo-guide",
      "es": "requisitos-de-foto-para-visa-de-singapur-imagen-tamano-pasaporte-singapore-visa",
      "fr": "exigences-photo-pour-visa-de-singapour-image-format-passeport-sav-singapore-visa",
      "ar": "متطلبات-صورة-تا-شيرة-سنغافورة-صورة-بحجم-جواز-السفر-save-ونقاط-التحقق",
      "zh-Hans": "新加坡签证照片要求-护照尺寸图像-save-上传与流程说明",
      "de": "singapur-visafoto-anforderungen-passbild-save-upload-und-verfahrenshinweise",
      "pt": "requisitos-de-foto-para-visto-de-singapura-imagem-tipo-passaporte-singapore-visa"
    }
  },
  {
    "slug": "ghana-visa-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "ghana-visa-photo-guide",
      "es": "requisitos-de-foto-para-visa-de-ghana-fotos-tamano-pasaporte-variacio-ghana-visa",
      "fr": "exigences-photo-pour-visa-ghaneen-photo-format-passeport-variations-s-ghana-visa",
      "ar": "متطلبات-صورة-تا-شيرة-غانا-صورة-بحجم-جواز-السفر-اختلافات-البعثات-وما-ي-ghana-visa",
      "zh-Hans": "加纳签证照片要求-护照尺寸照片-使团差异与提交前检查",
      "de": "ghana-visafoto-anforderungen-passbildformat-unterschiede-je-auslandsv-ghana-visa",
      "pt": "requisitos-de-foto-para-visto-de-gana-foto-tipo-passaporte-variacoes-ghana-visa"
    }
  },
  {
    "slug": "new-zealand-visa-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "new-zealand-visa-photo-guide",
      "es": "requisitos-de-foto-para-visa-de-nueva-zelanda",
      "fr": "exigences-de-photo-pour-visa-de-nouvelle-zelande",
      "ar": "متطلبات-صورة-تا-شيرة-لـ-نيوزيلندا",
      "zh-Hans": "新西兰-签证-照片要求",
      "de": "fotoanforderungen-fur-visum-in-neuseeland",
      "pt": "requisitos-de-foto-para-visto-de-nova-zelandia"
    }
  },
  {
    "slug": "australia-visa-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "australia-visa-photo-guide",
      "es": "requisitos-de-foto-para-visa-de-australia-captura-digital-rutas-c-australia-visa",
      "fr": "exigences-photo-pour-visa-australie-capture-numerique-routes-papi-australia-visa",
      "ar": "متطلبات-صورة-تا-شيرة-ا-ستراليا-الالتقاط-الرقمي-ومسارات-الصور-الور-australia-visa",
      "zh-Hans": "澳大利亚签证照片要求-数字申请采集-纸质照片路径和-35x45-毫米情况",
      "de": "fotoanforderungen-fur-australien-visum-digitale-app-erfassung-pap-australia-visa",
      "pt": "requisitos-de-foto-para-visto-da-australia-captura-digital-rotas-australia-visa"
    }
  },
  {
    "slug": "texas-driver-license-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "texas-driver-license-photo-guide",
      "es": "requisitos-de-foto-para-permiso-de-conducir-de-texas-estados-unidos",
      "fr": "exigences-de-photo-pour-permis-de-conduire-de-texas-etats-unis",
      "ar": "متطلبات-صورة-رخصة-قيادة-لـ-texas-الولايات-المتحدة",
      "zh-Hans": "texas-美国-驾驶证-照片要求",
      "de": "fotoanforderungen-fur-fuhrerschein-in-texas-vereinigte-staaten",
      "pt": "requisitos-de-foto-para-carta-de-conducao-de-texas-estados-unidos"
    }
  },
  {
    "slug": "ohio-driver-license-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "ohio-driver-license-photo-guide",
      "es": "requisitos-de-foto-para-permiso-de-conducir-de-ohio-estados-unidos",
      "fr": "exigences-de-photo-pour-permis-de-conduire-de-ohio-etats-unis",
      "ar": "متطلبات-صورة-رخصة-قيادة-لـ-ohio-الولايات-المتحدة",
      "zh-Hans": "ohio-美国-驾驶证-照片要求",
      "de": "fotoanforderungen-fur-fuhrerschein-in-ohio-vereinigte-staaten",
      "pt": "requisitos-de-foto-para-carta-de-conducao-de-ohio-estados-unidos"
    }
  },
  {
    "slug": "victoria-driving-licence-photo-guide",
    "updatedAt": "2026-05-26",
    "indexable": true,
    "localizedSlugs": {
      "en": "victoria-driving-licence-photo-guide",
      "es": "requisitos-de-foto-para-permiso-de-conducir-de-victoria-australia",
      "fr": "exigences-de-photo-pour-permis-de-conduire-de-victoria-australie",
      "ar": "متطلبات-صورة-رخصة-قيادة-لـ-victoria-ا-ستراليا",
      "zh-Hans": "victoria-澳大利亚-驾驶证-照片要求",
      "de": "fotoanforderungen-fur-fuhrerschein-in-victoria-australien",
      "pt": "requisitos-de-foto-para-carta-de-conducao-de-victoria-australia"
    }
  },
  {
    "slug": "western-australia-driving-licence-photo-guide",
    "updatedAt": "2026-05-14",
    "indexable": true,
    "localizedSlugs": {
      "en": "western-australia-driving-licence-photo-guide",
      "es": "requisitos-de-foto-para-permiso-de-conducir-de-western-australia-australia",
      "fr": "exigences-de-photo-pour-permis-de-conduire-de-western-australia-australie",
      "ar": "متطلبات-صورة-رخصة-قيادة-لـ-western-australia-ا-ستراليا",
      "zh-Hans": "western-australia-澳大利亚-驾驶证-照片要求",
      "de": "fotoanforderungen-fur-fuhrerschein-in-western-australia-australien",
      "pt": "requisitos-de-foto-para-carta-de-conducao-de-western-australia-australia"
    }
  }
] as const;

const POST_ROUTE_BY_BASE_SLUG = new Map(POST_ROUTE_INDEX.map((entry) => [entry.slug, entry]));
const POST_ROUTE_BY_LOCALE_SLUG: Record<Locale, Map<string, PostRouteEntry>> = {
  en: new Map(),
  es: new Map(),
  fr: new Map(),
  ar: new Map(),
  'zh-Hans': new Map(),
  de: new Map(),
  pt: new Map(),
};
const POST_ROUTE_BY_LEGACY_LOCALE_SLUG: Record<Locale, Map<string, PostRouteEntry>> = {
  en: new Map(),
  es: new Map(),
  fr: new Map(),
  ar: new Map(),
  'zh-Hans': new Map(),
  de: new Map(),
  pt: new Map(),
};

for (const entry of POST_ROUTE_INDEX) {
  for (const locale of Object.keys(POST_ROUTE_BY_LOCALE_SLUG) as Locale[]) {
    POST_ROUTE_BY_LOCALE_SLUG[locale].set(entry.localizedSlugs[locale], entry);
  }
}

for (const alias of legacyPostRouteAliases as readonly LegacyPostRouteAlias[]) {
  const entry = POST_ROUTE_BY_BASE_SLUG.get(alias.baseSlug);
  if (!entry || entry.localizedSlugs[alias.locale] === alias.legacySlug) continue;
  POST_ROUTE_BY_LEGACY_LOCALE_SLUG[alias.locale].set(alias.legacySlug, entry);
}

export function getPostRouteEntry(baseSlug: string): PostRouteEntry | undefined {
  return POST_ROUTE_BY_BASE_SLUG.get(baseSlug);
}

export function getLocalizedPostRouteSlug(locale: Locale, baseSlug: string): string {
  return POST_ROUTE_BY_BASE_SLUG.get(baseSlug)?.localizedSlugs[locale] ?? baseSlug;
}

export function resolvePostRouteEntryByLocalizedSlug(locale: Locale, routeSlug: string): PostRouteEntry | undefined {
  return POST_ROUTE_BY_LOCALE_SLUG[locale].get(routeSlug) ?? POST_ROUTE_BY_BASE_SLUG.get(routeSlug);
}

export function resolveLegacyPostRouteEntryByLocalizedSlug(locale: Locale, routeSlug: string): PostRouteEntry | undefined {
  return POST_ROUTE_BY_LEGACY_LOCALE_SLUG[locale].get(routeSlug);
}
